const cabinetOrigin = process.env.VUE_APP_CABINET_ORIGIN.toUpperCase()

export default {
	//login home page
	loginHeader: {
		contactUs: '문의하기',
	},
	loginPage: {
		instructionstitle1: '시간과 노력을 절약하세요!',
		instructionstitle2: '회원님께 딱 맞는 플랫폼',
		instructionstitle3: '',
		options1f: '캐비닛',
		options1l: '접속',
		options2f: 'IB 포털을 ',
		options2l: '입력하세요',
		options3f: 'Prop Reports ',
		options3l: '살펴보기',
		termsAndConditions: '이용약관',
		privacyPolicy: '개인 정보 보호 약관',
		amlPolicy: '자금세탁방지 약관',
		refundPolicy: '환불 약관',
		riskDisclosure: '리스크 공지',
		complaintsProcedure: '고객 불만 처리 절차',
		cookiePolicy: '쿠키 정책',
		userError:
			'입력한 비밀번호가 올바르지 않습니다. 검토 후 다시 시도해 주세요.',
		userErrorTwo:
			'입력하신 이메일이 등록되지 않았습니다. 다시 확인 후 시도해 주세요.',
		enterCodeBelow: '아래 상자에 인증 앱에서 제공한 코드를 입력하세요.',
		enterYourCode: '2FA 코드를 입력하세요',
		authCode: '인증코드',
		loginMobile: '귀하의 계정에 로그인하십시오 ',
		loginOr: '또는 이메일로 로그인하기:',
	},

	wellcomeComponent: {
		title: '관심을 가져주셔서 감사합니다',
		titlesub: '회원가입을 시작합니다.',
		subTitle:
			'고객님의 트레이딩 계정을 설정하고 신원을 확인하는데 필요한 정보를 수집하는 프로세스를 시작하겠습니다.',
		before: '시작하기 전에 다음 문서를 준비하십시오.',
		government: '• 정부 발급 사진 ID',
		proof: '• 거주지 증명서',
		agree:
			'*Tradeview Financial Markets S.A.C.에 동의합니다. 신분증을 포함한 개인정보를 제공하여 전자적으로 본인의 신원을 확인합니다. 이 정보는 정확성을 확인하고 다른 신뢰할 수 있는 소스에서 보유하거나 획득한 데이터와 일치시키기 위해 신뢰할 수 있는 신원 확인 서비스 제공업체와 공유됩니다.',
		agreeLATAM:
			'본인은 Tradeview Financial Markets S.A.C.가 신원 확인을 위해 개인 정보를 포함한 신분증 서류를 제공하여 전자적으로 본인의 신원을 확인하는 것에 동의합니다. 이 정보는 신뢰할 수 있는 신원 확인 서비스 제공자와 공유되며, 제공자가 보유하거나 다른 신뢰할 수 있는 출처에서 얻은 데이터와 대조하여 정확성을 확인할 것입니다.',
		btnContinue: '다음',
		btnGoBack: '돌아가기',
		btnConfirm: '완료하기',
		checkError: '정보 처리에 동의하려면 확인란을 선택하세요.',
	},

	loginBox: {
		title: '귀하의 계정에 로그인하십시오 ',
		logInGoogle: 'Google로 계속하기',
		logInFacebook: '페이스북으로 계속하기',
		or: '또는 이메일로 로그인하기:',
		email: '이메일',
		placeholderEmail: '이메일을 입력하세요',
		placeholderPassword: '비밀번호를 입력하세요',
		password: '비밀번호를 입력하세요',
		submit: '다음',
		forgot: '비밀번호를 잊으셨나요?',
		doNotAccount: '계정이 없나요?',
		signUp: '가입하기',
		tryFreeDemo: '무료 데모를 사용해 보세요',
		remember: '로그인 상태 유지',
		emailError: '이메일을 입력해주세요 ',
		passwordError: '비밀번호를 입력해주세요',
		passwordToEmail: '이메일을 확인해 주세요.',
		passwordToEmailDesc:
			'계정을 재설정할 수 있도록 임시 비밀번호를 보내드렸습니다.',
	},

	forgotPage: {
		instructionstitle1: '시간과 노력을 절약하세요!',
		instructionstitle2: '회원님께 딱 맞는 플랫폼',
		instructionstitle3: '',
		options1f: '규제되고',
		options1l: '안전함',
		options2f: '맞춤형 ',
		options2l: '지원',
		options3f: '업계최고',
		options3l: '유동성',
	},

	forgotBox: {
		title: '비밀번호 재설정',
		email: '이메일',
		text1: '아래에 등록된 이메일을 입력하시면 ',
		text2: '비밀번호 재설정 안내를 보내드립니다.',
		placeholderEmail: '이메일을 입력하세요',
		badFormatEmail: `입력한 메일이 올바른 형식인지 확인하세요.`,
		badEmail: '이메일을 입력해주세요',
		wrongEmail:
			'입력하신 이메일은 등록되지 않았습니다. 검토한 후 다시 시도해 주세요.',
		continue: '다음',
		limitExceeded: '한도 초과',
		requiredField: '이 필드는 필수입니다',
		goBackLogIn: '로그인으로 돌아가기',
	},

	verifiCode: {
		title: '이메일 주소를 확인하세요',
		text1: '등록된 이메일로 활성화 코드를 보내드렸습니다.',
		text2: '받은 편지함을 확인하고 아래 코드를 입력하세요.',
		label1: '인증코드',
		label2: '6자리 코드를 입력하세요. 예: 123456',
		label3: '입력한 코드가 잘못되었습니다. 다시 시도해 주세요.',
		submit: '제출하기',
		text3: '코드를 받지 못하셨나요? ',
		text4: '코드를 다시 보내세요',
		alert1: '일회성 코드가  로 전송되었습니다.',
		alert2: '지금은 코드를 다시 보낼 수 없습니다. 다시 시도해 주세요.',
		alert3: '인증 코드가 올바르지 않습니다. 다시 시도해 주세요.',
		error: '문제가 발생했습니다. {contactInfo} 으로 문의하세요.',
	},

	setPassword: {
		title: '새 비밀번호를 설정하세요',
		text1: '새 비밀번호를 입력해 주세요.',
		text2: '이전의 비밀번호와 다른 새 비밀번호를 입력해 주세요.',
		label1: '새 비밀번호',
		label2:
			'비밀번호는 8자 이상이어야 하며 소문자, 대문자, 숫자, 특수문자가 각각 1개씩 이상 포함되어야 합니다.비밀번호는 8자 이상이어야 하며 소문자, 대문자, 숫자, 특수문자가 각각 1개씩 이상 포함되어야 합니다.',
		label3: '비밀번호 확인',
		placeholder1: '새 비밀번호를 입력하세요',
		placeholder2: '새 비밀번호를 확인하세요',
		error1:
			'비밀번호는 8자 이상이어야 하며 소문자, 대문자, 숫자, 특수문자가 각각 1개씩 이상 포함되어야 합니다.',
		error2:
			'입력한 비밀번호가 일치하지 않습니다. 다시 한번 확인하신 후 다시 시도해 주세요.',
		description:
			'등록된 이메일로 활성화 코드를 보냈습니다. 받은 편지함을 확인하고 아래에 입력하세요. 활성화 코드를 확인한 후, 이전에 사용한 비밀번호와 다른 새 비밀번호를 입력하세요.',
	},

	setPasswordSuccess: {
		title1: '비밀번호가 성공적으로',
		title2: '재설정되었습니다!',
		login: '로그인',
	},

	consoleHeader: {
		account: '계정 #',
		balance: '전일예탁잔고',
		equity: '평가예탁잔고',
		free: '사용가능 증거금',
		margin: '증거금 비율',
		status: '상태',
		hello: '안녕하세요',
		logout: '로그아웃',
		confirm: '완료하기',
		outModal: '로그아웃하시겠습니까?',
		yes: '예',
		not: 'Not',
		settings: '설정',
		areYouDone: '나가시겠습니까?',
		areYouSure:
			'정말로 로그아웃하시겠습니까? 저장되지 않은 변경사항은 모두 손실됩니다.',
		yesLogOut: '예, 로그아웃합니다',
	},

	// Platforms page
	platforms: {
		description:
			'중요한 거래 도구와 계좌 정보를 쉽게 사용하여 이동 중이든 책상에 있든 제어할 수 있습니다. 원하는 작업 방식을 선택하고 가장 적합한 소프트웨어/앱을 다운로드하세요.',
		mainTitle: '어떻게 거래하시겠습니까?',
		metatrader4: {
			desc1: '사용자 친화적이고 커스텀 가능한 인터페이스',
			desc2: '효율적인 거래를 위한 빠른 실행 속도',
			desc3: '간편한 주문',
			desc4: '효과적인 포지션 관리',
			desc5: '가격 변동 시각화',
		},
		metatrader5: {
			desc1: '주요 거래 도구 및 계좌 정보',
			desc2: '시장의 중요한 이벤트를 놓치지 않도록 알림 설정',
			desc3: '자동 거래 지원',
			desc4: '80개 이상의 내장 지표 및 분석 도구',
			desc5: '향상된 거래 전략을 위한 고급 도구',
		},
		cTrader: {
			desc1: '빠르고 사용자 친화적인 거래 경험',
			desc2: '통화 시장에 직접 접근',
			desc3: '간편주문',
			desc4: 'DOM 시각화',
			desc5: '향상된 거래를 위한 첨단 기술',
		},
		sterling: {
			desc1: '커스텀 레이아웃 및 단축키',
			desc2: '레벨 I 및 레벨 II 실시간 시장 정보',
			desc3: '포지션 및 손익 실시간 모니터링',
			desc4: '기호당 60개 이상의 데이터 포인트를 갖춘 맞춤형 티커 워치리스트',
			desc5: '90개 이상의 연구 및 지표 차트 패키지',
		},
		lightspeed: {
			desc1: '가격이 다양한 여러 위치 찾기 소스',
			desc2: '사전 구성된 설정에 따른 맞춤형 주문',
			desc3: '복잡한 전략을 위한 옵션 주문 양식',
			desc4: '빠른 주문 입력을 위한 사용자 정의 가능한 관심 목록 및 단축키',
			desc5: '종합적인 위험 관리 설정',
		},

		takion: {
			desc1: '다양한 차트 유형, 기간 및 기술 지표.',
			desc2: '효율성을 위해 시장 접근을 통한 직접 거래',
			desc3: '실시간 시장 스캐너 및 뉴스 업데이트',
			desc4: '레벨 II 실시간 및 판매 데이터.',
			desc5: '원활한 거래 운영을 위한 레이어 및 작업 공간',
		},

		das: {
			desc1: '고급 주문 유형 및 실시간 차트',
			desc2: '다중 계정 관리',
			desc3: '빠른 주문 입력을 위한 맞춤형 단축키',
			desc4: '미국 주요 거래소에 대한 짧은 지연 주문 검증',
			desc5: '실시간 시장 데이터 액세스',
		},

		api: {
			desc1: '당사 거래 서버에 대한 직접 고속 연결',
			desc2: '빠른 실행 및 플랫폼 맞춤화',
			desc3: '제출 및 수신된 데이터에 대한 완전한 제어',
			desc4: '다양한 시장 및 지정가 주문 옵션',
			desc5: '거래 전략의 유연성',
		},
		cqg: {
			desc1: '사용하기 쉬운 거래 인터페이스',
			desc2: '필수 차트 및 분석',
			desc3: '히트맵을 포함한 다양한 견적 스타일의 실시간 데이터',
			desc4: '주문 및 포지션 관리',
			desc5: 'RSS 뉴스',
		},
		thanksForYourInterest: '트레이드뷰에 오신것을 환영합니다.',
		weWillContactYou:
			'Tradeview 담당자가 곧 연락하여 새 데모 계정 설정을 도와드릴 것입니다.',
		createAccountToDownload: '이 플랫폼을 다운로드하려면 계정을 만드세요',
		createAccount: '계정 만들기',
		platformNotCovered:
			'이 플랫폼은 기존 계정에서 다루어지지 않습니다. 설치하고 사용하려면 해당 마켓 및 플랫폼 전용 계정을 만드십시오.',
		btn_downd: '다운로드',
		btn_launch: '웹 버전',
		btn_request: '요청 시 다운로드',
		okay: '좋아요',
		continue: '다음',
		requestAccount: '계정 요청',
		disabledOptionAlert:
			'다운로드를 시작할 수 없습니다. 10초 정도 기다린 후 다시 시도하십시오.',
		modal_reminder: {
			title: '알림',
			descript1: '다운로드가 진행 중입니다!',
			descript2:
				'이메일을 통해 보내드린 로그인 정보를 사용하세요. 아직 이 플랫폼에서 계정을 요청하지 않았다면, ',
			descript3: '언제든지 그렇게 할 수 있습니다.',
			descript1sub: '접근하려면 ',
			descript2sub:
				'이메일을 통해 보내드린 로그인 정보를 사용하세요. 아직 이 플랫폼에서 계정을 요청하지 않았다면, ',
			descript3sub: '언제든지 그렇게 할 수 있습니다.',
		},
		modal_send: {
			title: '귀하의 요청이 전송되었습니다',
			descript:
				'관심을 가져주셔서 감사합니다! 선택하신 플랫폼 설정을 지원하기 위해 곧 연락드리겠습니다.',
		},
		acessPlatforms:
			'이러한 플랫폼에 액세스하려면 트레이드뷰 실계정이 필요하며 여기에서 요청할 수 있습니다. ',
		acessPlatformsContinue: '',
		webVersionModal: '웹 버전 실행',
		toAccess:
			'MT5에 접속하려면 이메일로 보낸 자격 증명을 사용하세요. 아직 해당 플랫폼의 계정을 신청하지 않았다면 지금 또는 언제든지 신청할 수 있습니다. 접속하려면 계정이 필요합니다.',
		selectTypeAccount: '웹 버전을 실행하려는 계정 유형을 선택하세요:',
		live: '라이브',
		demo: '데모',
		launch: '실행',
	},

	//History page
	history: {
		titleH: '거래내역',
		periodTimeL: '기간',
		periodTimeP: '전체 내역',
		typeL: '타입',
		typeP: '주문형태 선택',
		platformL: '플랫폼',
		platformP: '플랫폼을 선택하세요',
		accountL: '거래계좌',
		accountP: '계좌번호',
		fromL: '기간 시작',
		fromP: 'mm/dd/yyyy',
		toL: '기간 끝',
		toP: 'mm/dd/yyyy',
		clearBtn: '지우기',
		exportBtn: '내보내기',
		getBtn: '필터 적용',
		optionsAccounts: '거래 계좌를 선택하세요',
		infoAlertD: '계정을 선택하세요.',
		noHistoryYet1: '선택한 계정 필터',
		noHistoryYet2: '아직 기록이 없습니다',
		platformAlertD:
			'참고: 아래 필터와 표에는 MT4, MT5 및 cTrader 플랫폼의 계정만 표시됩니다. 다른 플랫폼의 계정의 경우 해당 플랫폼 내에서 거래 내역에 액세스할 수 있습니다.',
		accountTypeH: '계좌 유형',
		accountTypeP: '계정 유형을 선택하세요',
		alertExport: '귀하의 정보가 성공적으로 내보내졌습니다.',
		btnFilter: '필터',
		alertPlatforMobile:
			'참고: 아래에는 MT4, MT5 및 cTrader 계정만 표시됩니다. 귀하는 해당 플랫폼 내의 다른 플랫폼에 대한 거래 내역에 접근할 수 있습니다.',
		modalHeader: '정말 떠나시겠어요?',
		modalDescription:
			'지금 떠나면 프로세스가 완료되지 않고 지금까지 진행한 모든 내용을 잃게 됩니다.',
		btnModalCancel: '취소',
		btnModalYes: '네, 나가겠습니다.',
		filterbyactivity: '활동 유형별로 필터링',
		accountTooltip:
			'해당 이동과 관련된 계좌 번호입니다. 이 경우 이체에 대한 아이콘이 표시됩니다.',
		accountTooltip2: '이 아이콘은 조회한 계좌로 입금된 이체를 나타냅니다.',
		accountTooltip3: '계좌에서 출금된 이체입니다.',
		accountTooltipIn:
			'이 열에 나열된 출처 계좌에서 조회한 계좌로 입금된 이체를 나타냅니다.',
		accountTooltipOut:
			'조회한 계좌에서 출금되어 이 열에 나열된 목적지 계좌로 송금된 이체를 나타냅니다.',
	},

	// Withdraw page
	withdraw: {
		sourceAccount: '출금 계정',
		currency: '통화',
		currencyType: '통화 유형',
		details: '예금주 은행 세부정보',
		beneficiaryDetails: '예금주 은행 세부정보',
		swiftt: 'Swift',
		branchCode: '지점 이름',
		enterbranch: '지점 코드를 입력하세요',
		branch: '지점명',
		province: '주/도',
		city: '시',
		bank: 'DBS은행',
		bankK: '은행',
		bankTransfer: '이체할 은행을 선택하세요',
		withdrawFunds: '출금',
		withdrawalMethod: '출금방법 ',
		withdrawalAmmount: '출금 가능 금액',
		keepInMind: '기억하세요:',
		withdrawalCalendar:
			'IB 파트너의 인출은 한 달에 2번으로 제한되며, 최소 인출 금액은 $100 USD 입니다. 세번째 출금부터는 $50의 수수료가 부과됩니다.',
		withdrawalMustMatchDeposit:
			'선택한 출금 방식은 입금 방식과 일치해야 합니다. 신용카드 및 디지털 지갑 입금의 경우 인출 금액은 원래 입금 금액을 초과할 수 없는점 참고 부탁드립니다.',
		beneficiaryName: '예금주명',
		beneficiaryAccount: '수취인 계좌 이름',
		bankAddress: '은행 주소',
		enterBankAddress: '은행 주소를 입력해 주세요.',
		enterBeneficiaryName: '예금주명을 입력하세요 ',
		beneficiaryAddress: '예금주 주소',
		enterBeneficiaryAddress: '예금주의 주소를 입력하세요',
		enterYourAddress: '예금주 주소를 입력하세요',
		accountNumber: '계좌번호',
		iban: '(IBAN)',
		enterAccountNumber: '계좌번호를 입력하세요',
		bankName: '은행명 ',
		enterBankName: '은행명을 입력하세요. ',
		swiftCode: 'SWIFT 코드:',
		enterSwiftCode: 'SWIFT 코드를 입력하세요.',
		abaNumber: 'ABA 번호 (선택 과목)',
		enterAbaNumber: 'ABA 번호를 입력하세요.',
		sortCodeClabe: 'CLABE',
		enterSortCodeClabe: 'CLABE를 입력하세요.',
		referenceNumber: '레퍼런스',
		enterReferenceNumber: '레퍼런스를 입력하세요',
		associatedEmail: '이메일',
		associatedEmailLabel: '이메일',
		enterAssociatedEmailAccount: '이메일을 입력하세요',
		doYouNeedIntermediary: '중개 은행이 필요한가요?',
		selectAnOption: '선택하세요',
		pleaseSelectAnOption: '옵션을 선택해주세요',
		enterCashAmount: '금액을 입력하세요.',
		helperCashTransfer:
			'최소 $10 USD. 10K를 초과하는 이체는 수동 검토가 필요합니다.',
		intermediaryBank: '중개은행 세부정보',
		intermediaryBankk: '중개 은행',
		ifNeeded: '(해당되는 경우)',
		intermediaryBankName: '중개은행 이름',
		banescoAccountName: '계정 이름',
		enterAccountName: '계정 이름을 입력하세요',
		enterBankName: '은행 이름을 입력하세요',
		clabe: 'CLABE',
		clabealias: '(계좌 번호)',
		enterclabe: 'CLABE를 입력하세요',
		pesosAccount: '페소 계좌 번호',
		enterIntermediaryBankName: '중개은행명을 입력하세요.',
		intermediaryBankAddress: '중개은행 주소',
		enterintermediaryBankAddress: '중개은행 주소를 입력하세요.',
		ibanNumber: 'IBAN 번호',
		enterIbanNumber: 'IBAN 번호를 입력하세요 ',
		withdrawalCompleted: '출금이 완료되었습니다!',
		withdrawalIsComplet: '출금이 검토 중입니다.',
		withdrawalIsCompletDescription:
			'출금이 현재 검토 중입니다. 출금 절차가 완료되면 저희 팀이 이메일을 통해 연락드리겠습니다.',
		withdrawalCompletedDescription:
			'자금은 곧 목적지 계좌에서 이용 가능해집니다. 처리 시간은 선택한 출금 방법에 따라 다릅니다.',
		withdrawNotCompleted: '출금을 완료할 수 없습니다.',
		withdrawNotCompletedDescription:
			'고객님의 출금을 처리하는 동안 문제가 발생했습니다. 출금정보를 확인하신 후 다시 시도해주세요. 문제가 지속되면 당사에 문의해 주세요. ',
		contactUs: '문의하기.',
		goToMyAccount: '내 계정으로 이동',
		creditCardDetails: '신용카드 세부정보',
		important: '알림:',
		withdrawalsExceeding:
			'신용카드 출금은 환불의 개념으로 처리되기 때문에 입금액 이상을 출금하실 수 없습니다. 입금액을 초과한 출금에 대해서는 다른 출금경로로 신청해주시기 바랍니다,',
		creditCardLastDigits: '신용카드 마지막 4자리 ',
		enterCreditCardLastDigits: '신용카드 마지막 4자리를 입력하세요.',
		netellerAccountDetails: 'Neteller 계정 세부정보',
		netellerComission:
			'입출금 시 2% - 계좌에 3개월 이상 자금을 보유하거나 최소 로트 요구 사항을 충족하는 경우 수수료가 면제됩니다(로트 계산에 대한 도움은 계정 관리자에게 문의하세요).',
		netellerComissionMena:
			'Neteller와 관련된 비용 증가로 인해, Neteller를 사용한 모든 입금 및 출금에 1%의 수수료가 부과됩니다. 계좌 검토 후, Tradeview 담당자와의 상담을 통해 특정 상황에서는 수수료가 면제될 수 있습니다.',
		skrillAccountDetails: 'Skrill 계정 세부정보',
		upholdAccountDetails: 'Uphold 계정 세부정보',
		bitwalletAccountDetails: 'Bitwallet 계정 세부정보',
		interacAccountDetails: 'Interac e-Transfer 계좌 정보',
		interacHelpMsg: '*Interact Corp.의 상표이며, 라이선스 하에 사용됩니다.',
		upholdComission:
			'Uphold 계정으로 보내는 경우: 수수료가 없습니다. 다른 암호화폐 지갑으로 보내는 경우: TV는 수수료를 부과하지 않지만 Uphold는 다음과 같은 요금을 부과합니다. 전환수수료(1.05%), 네트워크수수료(0.0003 BTC), 출금수수료(0.0004 BTC).',
		bitPayTitle: 'Bitpay 계정 세부정보',
		destinationAccount: '받는 계정',
		bitPayCommision:
			'암호화폐 프로세서는 다음과 같은 수수료를 청구합니다. 전환수수료(1.05%), 네트워크수수료(0.0003 BTC), 출금수수료(0.0003 BTC).',
		needYourAuth: '승인이 필요합니다:',
		confirmThoughtEmail:
			'출금 요청을 보낸 후 계정에 등록된 이메일을 통해 승인이 필요합니다. ',
		wallet: '코인 지갑',
		enterYourWallet: '지갑을 입력해 주세요',
		enteryourEmailAccount: '이메일을 입력하세요',
		sticPayAccountDetails: 'SticPay 계정 세부정보',
		voletAccountDetails: 'Volet  계정 세부정보',
		interacAccountDetails: 'Interac e-Transfer 계좌 정보',
		fasapayAccountDetails: 'Fasapay 계정 세부정보',
		searchABank: '은행 찾기',
		searchAnAccount: '계좌 검색',
		ibanIfApplicable: '(IBAN, 해당되는 경우) ',
		beneficiaryBankName: '예금주 은행 이름:예금주 은행 이름',
		enterBeneficiaryBankName: '예금주 은행 이름',
		enterYourProvince: '주를 입력해 주세요',
		enterYourCity: '도시를 입력해 주세요',
		unionPayDetails: 'UnionPay 세부정보',
		jpayDetails: 'JPay 계정 세부정보 ',
		jpayAccountDetails: 'JPay 계정 세부정보 ',
		walletAndCrypto: '코인 지갑과 암호화폐',
		walletAndCryptoAlert: '암호화폐 출금시 0.7%의 전환수수료가 적용됩니다.',
		crypto: '코인',
		selectCrypto: '암호화폐를 선택해 주세요',
		tag: '태그',
		enter: '입력하세요',
		cryptocurrency: '코인',
		enterCryptocurrency: '암호화폐를 입력하세요',
		otherCurrency: '기타 암호화폐',
		enterOtherCurrency: '다른 암호화폐를 입력하세요',
		areYouSure: '정말 떠나시겠어요?',
		ifYouLeaveNow:
			'지금 떠나면 프로세스가 완료되지 않고 지금까지 진행한 모든 내용을 잃게 됩니다.',
		noStay: '아니요',
		yesLeave: '네, 나가겠습니다',
		requestSubmited: '고객님의 요청이 전송되었습니다!',
		reviewEmail: '이메일 받은편지함을 확인하세요.',
		unsuccessfulWithdraw: '출금을 완료할 수 없습니다.',
		reviewAgain:
			'출금 정보를 확인하고 다시 시도해 주세요. 문제가 계속 발생하면,',
		amountTryAgain: '금액이 이체 가능 금액을 초과했습니다. 다시 시도해 보세요.',
		amountTryAgainWithdraw:
			'입력한 금액이 출금 가능한 금액을 초과합니다. 금액을 변경하고 다시 시도하십시오.',
		minimunAmount: '신용카드 최소 인출 금액은 $10 USD입니다.',
		minimunAmount100: '이 방법의 최소 출금액은 $100 USD입니다. ',
		minimunAmount0: '이 방법의 최소 출금액은 예: 0.00001 BTC입니다.',
		invalidEmail: '잘못된 이메일 형식',
		invalidAccountNumber: '잘못된 계좌 번호 형식',
		noAvailableOptions: '사용 가능한 옵션이 없습니다',
		closeModal:
			'종료하기로 결정하면 지금까지 진행한 모든 내용이 손실된다는 점에 유의하세요. 나중에 자금을 인출할 계획이라면 절차를 다시 시작해야 합니다. ',
		successWithdraw:
			'감사합니다. 출금신청이 접수되었습니다. 모든 출금신청은 심사와 함께 진행되며, 처리 시간은 출금 방법에 따라 달라질 수 있습니다. ',
		fundCreditCard: '신용카드로 입금',
		selectMethod:
			'출금 방법은 고객님의 계좌에서 자금을 인출하는 데 사용할 수 있는 옵션을 나타냅니다. 은행계좌, 신용카드, 각종 전자지갑, 암호화폐 지갑 등으로 출금할 수 있습니다.',
		invalidCreditCardDigits: '잘못된 카드 번호 ',
		phone: '전화번호',
		enterYourPhone: '전화번호를 입력하세요 ',
		invalidPhone: '잘못된 전화번호 형식',
		modalPreferences: '현재 로그인 정보를 다시 묻지 않기',
		bankFee: '$35 USD',
		bankBranch: '은행 지점',
		enterBankBranch: '은행 지점을 입력하세요',
		branchProvince: '지점 소재지',
		enterBranchProvince: '지점 소재지를 입력하세요',
		BranchCity: '지점 도시',
		enterBranchCity: '지점 도시를 입력하세요',
	},

	//Account Activity page
	accountActivity: {
		title: '계좌 활동',
		from: '기간 시작',
		to: '기간 끝',
		type: '타입',
		platform: '거래 종목',
		placeholderAccount: '거래계좌',
		account: '거래계좌',
		get: '받기',
		row: '페이지 행',
		download: '보고서 다운로드',
		back: '뒤로',
		confirm: '완료하기',
		close: '닫기',
		error: '오류! 빈 필드가 있을 수 없습니다',
		errorTwo: '오류! 필드 유형을 선택해야 합니다',
		activityid: '활동 ID',
		platfomr: '플랫폼',
		date: '날짜 / 시간',
		activity: '활동',
		profit: '손익',
		timeSegmentation: '시간 분할',
		timeFrame: '기간을 선택하세요',
		selectType: '주문형태 선택',
		selectMarket: '시장 선택',
		tradingAccount: '거래 계좌를 선택하세요',
		segmentation: '시간 분할',
		segmentationPlaceholder: '기간을 선택하세요',
		platformPlaceholder: '플랫폼을 선택하세요',
		alert: '귀하의 정보가 성공적으로 내보내졌습니다.',
		infoYet: '선택한 필터로는 결과가 없습니다. 다시 시도해 주세요.',
	},

	//tradingHistory
	tradingHistory: {
		title: '거래 내역',
		from: '기간 시작',
		to: '기간 끝',
		type: '타입',
		platform: '플랫폼',
		placeholderAccount: '거래계좌',
		account: '계정',
		get: '받기',
		row: '페이지 행',
		download: '보고서 다운로드',
		back: '뒤로',
		confirm: '완료하기',
		close: '닫기',
		error: '오류! 빈 필드가 있을 수 없습니다',
		errorTwo: '오류! 필드 유형을 선택해야 합니다',
		deal: '주문번호',
		entryTime: '진입시간',
		typr: '타입',
		simbol: '종목명',
		volume: '계약수',
		entryPrice: '진입가',
		sl: 'S/L',
		tp: 'T/P',
		exitTime: '진출시간',
		exitPrice: '종가',
		commision: '수수료',
		bankFee: '은행 수수료',
		swap: '롤오버',
		profit: '손익',
		dateFrom: 'yyyy/mm/dd',
		dateTo: 'yyyy/mm/dd',
		openingTime: '진입 시간',
		openingPrice: '개장가',
		stopLoss: '손절매 (SL)',
		takeProfit: '익절매 (TP)',
		closingTime: '진출 시간',
		closingPrice: '종가',
		comission: '위원회',
		time: '시간',
	},

	//Transfer page
	transfer: {
		mainTitle: '내부 이체',
		isBackValidation:
			'저희 팀이 이체를 승인하기 위해 검토해야 합니다. 영업일 기준 최대 24시간이 소요될 수 있습니다.',
		pleaseNote:
			'참고: 내부이체는 동일한 사용자가 소유한 계정 간에만 허용됩니다.',
		mena: {
			consentCheck:
				'확인란에 체크함으로서 나는 하나의 Tradeview Financial Markets S.A.C.계좌로부터 다른 계정으로 자금 이체를 요청했음을 이해합니다.',
		},
		ltd: {
			consentCheck:
				'확인란에 체크함으로서 나는 하나의 Tradeview Financial Markets S.A.C.계좌로부터 다른 계정으로 자금 이체를 요청했음을 이해합니다.',
		},
		latam: {
			consentCheck:
				'체크박스를 선택함으로써, 저는 Tradeview Financial Markets S.A.C. 계좌에서 본인의 다른 Tradeview Financial Markets S.A.C. 계좌로 자금을 이체 요청했음을 이해합니다.',
		},
		markConsentCheck:
			'계속하려면 승인 확인란을 선택해야 합니다. 그렇게 해주세요.',
		transferAmount: '이체가능금액',
		transferCompleted: '전송이 완료되었습니다.',
		transferReview: '이체 검토 중',
		transferInCompleted: '전송이 완료되지 않았습니다.',
		transferInCompletedDescription:
			'송금을 처리하는 중에 문제가 발생했습니다. 계정 정보를 확인하고 다시 시도해 주세요. 문제가 계속되면 당사에 문의하세요.',
		transferDescription: '감사합니다. 출금신청이 접수되었습니다. ',
		transferDescriptionReview:
			'이체가 현재 검토 중입니다. 이체 절차가 완료되면 저희 팀이 이메일로 연락드리겠습니다.',
		destinationAccount: '받는 계정',
		minimunAmount: '최소 이체 가능 금액은 $10입니다.',
	},

	//Accounts
	accounts: {
		refresh: '잔액 새로 고침',
		liveAccounts: '라이브 계정',
		demoAccounts: '모의 계정',

		createLive: '+ 새계정 생성',
		createDemo: '+ 새 데모 계정 만들기',
		refresh: '잔액 새로고침',
		createAccount: '새 계정 만들기',
		createDemoAccount: '새 데모 계정 만들기',
		createLiveAccount: '새계정 생성',
		livee: '라이브',
		demoo: '모의계정',
		yourBalance: '전일예탁잔고',
		equityy: '자산',
		marginLevel: '증거금 비율(%)',
		freeMargin: '사용가능 증거금',
		statuss: '상태',
		leveragee: '레버리지',
		credit: '신용',
		phone: '전화번호',
		selectLeverage: '레버리지를 선택하세요',
		noLiveAccount:
			'라이브 계정이 없습니다. 귀하의 필요에 맞는 것을 선택하고 지금 거래를 시작하십시오.',
		noDemoAccount:
			'데모 계정이 없습니다. 고객님께 맞는 계좌를 선택하시고 모의투자를 진행하세요.',
		tradingInstrument: '거래시장',
		tradingMethodTooltip:
			'거래 시장은 귀하가 참여할 수 있는 다양한 시장 유형을 의미합니다. 종종 유가증권이라고도 불리는 여기에는 상품 선물, 주식, CFD, 통화, 금속 등이 포함됩니다 <br><br>어떤 시장을 선택해야 할지 모르시나요? 여기에서 검토할 수 있습니다.',
		here: '여기',
		selectAMarket: '거래시장을 선택하세요',
		platform: '플랫폼',
		selectAPlatform: '플랫폼을 선택하세요',
		cashAmount: '현금금액',
		selectCashAmount: '현금금액을 선택하세요',
		accountType: '계좌 유형',
		selectAnAccount: '계정 유형을 선택하세요',
		currencyy: '통화 유형',
		selectACurrency: '통화를 선택하세요',
		platformTooltip:
			'플랫폼은 귀하의 계정에서 거래를 실행하는 데 사용하게 될 소프트웨어입니다. <br><br> 어떤 플랫폼을 선택해야 할지 모르시나요? 여기에서 검토할 수 있습니다.',
		accountTypeTooltip:
			'계좌 유형을 통해 계좌의 거래 조건(레버리지, 스프레드, 커미션)을 선택할 수 있습니다.',
		accountTypeTooltip2: '여기에서 각 계정 유형의 조건을 검토할 수 있습니다.',
		applicationCompleted: '신청이 완료되었습니다!',
		applicationCompletedDescription:
			'라이브 계좌 신청서는 현재 검토 중이며 추가 문서가 필요한 경우 당사 담당자가 연락할 것입니다.',
		applicationError: '신청서가 제출되지 않았습니다.',
		applicationErrorDescription:
			'신청서를 보내는 중 오류가 발생했습니다. 트레이드뷰 IT팀에 이 문제가 리포트되었습니다. ',
		applicationErrorDescription2: '다시 시도해 보시고 문제가 지속되면,',
		sureToLeave: '정말 떠나시겠어요?',
		processUncompleted:
			'지금 떠나면 프로세스가 완료되지 않고 지금까지 진행한 모든 내용을 잃게 됩니다.',
		cardPlatform: '플랫폼',
		setDemoAccount:
			'고객님의 새 데모 계정을 설정하는 중입니다. 준비가 완료되면 여기에서 모든 세부정보를 확인할 수 있습니다.',
		cancel: '취소',
		active: '활성화',
		accountSettings: '계정 설정',
		changePw: '이 계정의 비밀번호 변경',
		changeLv: '이 계정의 레버리지 변경',
		setLv: '계정의 새로운 레버리지를 설정하세요',
		underReview: '업데이트가 검토 중입니다',
		underReviewDesc:
			'새로운 계정 레버리지가 검토 중이며 곧 확인될 예정입니다. 프로세스가 완료되면 팀에서 이메일로 연락드리겠습니다.',
		successLev: '레버리지가 성공적으로 업데이트되었습니다!',
		changePsw: '비밀번호 변경',
		forgotPw: '비밀번호를 잊으셨나요? {contact}에 문의하세요.',
		updatePw: '비밀번호가 성공적으로 업데이트되었습니다!',
		statusTooltip:
			'계정이 비활성 상태인 이유는 요청된 정보나 문서가 누락되는 등 여러 가지가 있을 수 있습니다. 알림을 확인하려면 캐비닛을 확인하세요. 이유가 불확실한 경우, {contact}에 문의하세요.',
		failedReq: '죄송합니다! 오류가 발생했습니다',
		failedReqDesc:
			'다시 시도해 주세요. 문제가 계속되면 {contact}에 문의하여 도움을 받으세요.',
		forex: 'Forex and CFDs',
	},

	//CreateDemoAccounts
	demoAccounts: {
		login: '로그인',
		pass: '비밀번호',
		currencyTwo: '통화',
		server: '서버',
		ilc: 'iLC',
		xleverage: 'xLeverage',
		dontForget:
			'버튼을 클릭하거나 이 창을 닫기 전에 로그인정보를 저장하세요. 이 정보는 등록된 이메일로도 전송됩니다.',
		downloadCred: '로그인 정보 받기',
		choosePlatform:
			'축하합니다! 이제 귀하의 거래 플랫폼을 선택하고 다운로드할 준비가 되었습니다.',
		ifYouChooseMT4:
			'Mac OS용 MetaTrader 4를 선택한 경우 설치 과정이 다르다는 점에 유의하세요. 여기에서 설치 방법을 찾을 수 있습니다.',
		ifYouChooseMT4Continuation: '',
		thanksForRegistering: '가입해주셔서 감사합니다!',
		otherStock:
			'Tradeview 담당자가 곧 연락하여 새 데모 계정 설정을 도와드릴 것입니다.',
		stockMT52: '귀하의 계정이 설정되는 동안,  ',
		stockMT53: '우리 홈페이지를 찾아보세요',
		stockMT54: 'Tradeview에 대해 자세히 알아보세요.',
		accountTypeDemo:
			'계좌 유형을 통해 귀하의 계좌에서 사용할 수 있는 레버리지를 선택할 수 있습니다. <br><br> X-레버리지: 1:400 <br> ILC: 1:200 <br> 주식: 1:1 <br><br> 어떤 계정 유형을 선택해야 할지 모르시나요? 여기에서 검토할 수 있습니다.',
		applicationCompleted: '귀하의 데모 계정이 생성되었습니다!',
		pdfCredentialTitle: '친애하는 트레이더님',
		pdfCredentialDescription1:
			'저희와 함께 거래 여정을 시작해 주셔서 감사합니다.',
		pdfCredentialDescription2: '저희는 당신을 환영하게 되어 매우 기쁩니다.',
		pdfCredentialDescription3: '다음은 귀하의 계정 정보입니다:',
		pdfCredentialEmail: '이메일:',
		pdfCredentialPassword: '비밀번호:',
		pdfCredentialCurrency: '통화:',
		pdfCredentialServer: '서버:',
		pdfCredentialInstructions: '지침:',
		pdfCredentialInstructions2: '등록된 이메일과 비밀번호를 사용하세요',
		pdfCredentialTo: '기간 끝',
		pdfCredentiallogin: '로그인',
		pdfCredentialTVAccount: 'Tradeview 계정에 로그인하기 위해.',
		pdfCredentialChangeP: '설정 섹션에서 비밀번호를 변경하거나 2단계',
		pdfCredentialSettings: '인증을 설정할 수 있습니다.',
		pdfCredentialFamiliarize: '플랫폼을 익히고, 기능을 탐색하며,',
		pdfCredentialExperience: 'Tradeview의 차이를 경험해 보세요.',
		pdfCredentialSupport:
			'저희는 언제나 당신을 지원할 준비가 되어 있습니다. 질문이 있으시거나',
		pdfCredentialNeed:
			'도움이 필요하시면, 저희 전담 지원 팀에 언제든지 연락해 주세요.',
		pdfCredentialTeam: '지원팀.',
		pdfCredentialHappy: '즐거운 거래 되세요!',
		pdfCredentialRegards: '감사합니다,',
		pdfCredentialTVTeam: 'Tradeview 팀 드림',
	},

	//Create Live Accounts
	liveAccount: {
		login: '로그인',
		pass: '비밀번호',
		server: '서버',
		platform: '플랫폼',
		status: '상태',
		statusFalse: '사용',
		statusTrue: '사용 안 함',
		dontForget:
			'버튼을 클릭하거나 이 창을 닫기 전에 로그인정보를 저장하세요. 이 정보는 등록된 이메일로도 전송됩니다.',
		downloadCred: '로그인 정보 받기',
		applicationCompleted: '실거래 계좌가 생성되었습니다!',
	},

	//credit card
	credit: {
		edit: '수정하기',
	},

	//Banck Transfer add found Skrill
	addFounds: {
		amount: '금액',
	},

	//fidelity
	fidelity: {
		routingNum: '라우팅 번호',
		swiftCodebic: 'SWIFT 코드/BIC',
		disclaimer:
			'이 입금 지침은 케이맨 제도 거주자에게만 적용됩니다. 케이맨섬에서 송금하지 않는 경우 대체 은행을 이용하시기 바랍니다.',
	},

	//Bbva
	bbva: {
		ruc: 'RUC:',
		accountninfo: '0011-0351-0100035781',
		nameBenef: '예금주명',
		interbank: '중개은행 번호(CCI)',
	},

	//deposit
	deposit: {
		title: '입금 방법을 선택하세요',
		depositMethod: '입금방법',
		processingCards: '처리 시간',
		fee: '요금',
		crypto: '암호화폐',
		digitalWallets: '전자지갑',
		cardTransfer: '신용카드',
		wireTransfer: '은행 송금',
		btnDepositFunds: '입금하기',
		selectAnOption: '입금방법을 선택하세요',
		depositUnderReview: '입금 검토 중',
		depositUnderReviewDescription:
			'입금이 현재 검토 중입니다. 입금 절차가 완료되면 팀에서 이메일로 연락드리겠습니다.',
		depositUnderReviewErrorDescription:
			'입금을 처리하는 중 문제가 발생했습니다. 결제 정보를 확인하고 다시 시도해 주세요. 문제가 지속되면 문의해 주세요.',
		depositCompleted: '입금이 완료되었습니다!',
		depositCompletedDescription:
			'곧 귀하의 대상 계좌에서 자금을 사용할 수 있게 됩니다. 처리 시간은 선택한 입금 방법에 따라 다릅니다.',
		despositInCompletedDescription:
			'입금을 처리하는 동안 문제가 발생했습니다. 결제 정보를 확인하고 다시 시도해 주세요. 문제가 계속되면 당사에 문의하세요.',
		contactUs: '문의하기',
		depositNotCompleted: '입금이 완료되지 않았습니다.',
		depositNotCompletedDescription:
			'입금액 정보를 검토한 후 다시 시도해 주세요. 문제가 계속되면 당사에 문의해 주세요.',
		depositWithClick: '또는 한 번의 클릭이나 스캔으로 손쉽게 입금하세요.',
		keepInMind: '기억하세요:',
		keepInMindTC:
			'24시간 동안 5번 입금 할 수 있습니다. 24시간이 지나면 재입금 가능합니다.',
		ltd: {
			depositDisclaimer:
				'손실이 초기투자자산 금액을 초과할 수도 있습니다. 제 3 자의 입금은 허용되지 않습니다. 모든 입금은 계좌 소유자의 명의로 이루어져야 합니다. 기본통화는 USD 입니다.',
		},
		latam: {
			depositDisclaimer:
				'손실이 초기투자자산 금액을 초과할 수도 있습니다. 제 3 자의 입금은 허용되지 않습니다. 모든 입금은 계좌 소유자의 명의로 이루어져야 합니다.',
		},
		accountNumberTitle: '거래계좌번호',
		accountNumberDescription: '입금할 계좌를 선택하세요',
		currencyTitle: '통화',
		currencyDescription: '통화를 선택하세요',
		amountTitle: '금액',
		amountDescription: '금액을 입력하세요.',
		phoneNumberTitle: '전화 번호',
		confirmTitle: '거래 세부정보를 검토하세요.',
		confirmDescription:
			'잠시 시간을 내어 아래 거래 세부정보가 올바른지 확인하세요.',
		upholdCommission:
			'사용자는 암호화폐 거래 수수료를 부담할 책임이 있습니다. 수수료 값은 이체 금액에 따라 다릅니다.',
		upholdBanningTitle: '사용할 수 없는 지역',
		upholdBanningDescription:
			'미국 법률에 따라 Uphold는 다음 국가의 거주자에게 서비스를 제공하지 않습니다.',
		depositAmount: '입금 금액을 입력하세요',
		btcAlertTitle: 'BTC 입금 수수료',
		btcAlertMessage:
			'모든 거래에 BTC Fiat 환전 수수료가 적용됩니다. 수수료는 $250K 이하의 거래에는 1%, $250K 이상의 거래에는 1.5%입니다.',
		upholdWarningTitle: 'Tradeview로 직접 BTC 입금 시 수수료',
		upholdWarningMessage:
			'$250K까지의 거래에는 1% BTC-피아트 환전 수수료가 적용되며, $250K 이상의 거래에는 1.5%가 적용됩니다.',
		bitPayCommission:
			'암호화폐 거래 수수료는 사용자 부담입니다 (수수료는 전송 금액에 따라 달라집니다).',
		bitPayWarningTitle: '암호화폐 프로세서는 다음과 같은 수수료를 청구합니다.',
		bitPayWarningMessage:
			'거래소 수수료: (1.05%), 네트워크 수수료 (0.0003 BTC), 출금 수수료 (0.0003 BTC)',
		bitpayFooterInfo:
			'알림: Tradeview는 입출금 프로세스 중 환차에 따른 이익이나 손실에 대해 책임을 지지 않습니다.',
		interacFooterInfo:
			'Tradeview Financial Markets S.A.C.는 출금을 처리하는 대신 신용카드를 통한 입금에 대해 환불할 권리를 보유합니다.',
		tetherWarningTitle: '수수료',
		tetherWarningMessage:
			'암호화폐를 사용하여 입금할 때는 0.7%의 환전 수수료가 부과됩니다.',
		copied: '복사완료!',
		tetherHashTitle: '해쉬',
		tetherHashDescription: '해쉬를 입력하세요',
		tetherTooltip:
			'해시는 암호화 기법을 통해 무작위로 생성된 숫자와 문자로 구성된 코드입니다.',
		netellerFooterInfo:
			'손실이 초기투자자산 금액을 초과할 수도 있습니다. 제 3 자의 입금은 허용되지 않습니다. 모든 입금은 계좌 소유자의 명의로 이루어져야 합니다.',
		fasapayAccountTitle: 'Fasapay 계정',
		fasapayAccountDescription: 'FasaPay 계좌 ID를 입력하세요',
		jpayFooterInfo: '환율: 1 USD = 7 CNY(RMB)',
		addressTitle: '주소:',
		zipCodeTitle: '우편번호',
		zipCodeDescription: '우편번호를 입력하세요',
		countryTitle: '국가',
		countryDescription: '국가를 선택하세요',
		cityTitle: '시',
		cityPlaceholder: '도시를 선택하세요',
		skrillFooterInfo:
			'손실이 초기투자자산 금액을 초과할 수도 있습니다. 제 3 자의 입금은 허용되지 않습니다. 모든 입금은 계좌 소유자의 명의로 이루어져야 합니다. ',
		bitwalletFooterInfo:
			'손실이 초기투자자산 금액을 초과할 수도 있습니다. 제 3 자의 입금은 허용되지 않습니다. 모든 입금은 계좌 소유자의 명의로 이루어져야 합니다. ',
		clickBank:
			'선호하는 은행 이름을 클릭하여 계좌 관련 필수 정보를 확인하고, 은행 플랫폼을 통해 입금을 완료하세요. 이체가 완료된 후, 거래 영수증을 브로커에게 보내 확인을 요청하세요. 확인이 완료되면 자금이 즉시 거래 계좌에 추가되어 원활하고 효율적인 절차가 보장됩니다.',
		banks: '은행',
		processingTime: '처리기간 :',
		commision: '수수료:',
		bankProcessingTime: '처리기간 : 영업일 기준 약 1~2일 소요',
		bankCommision: '수수료 : 아니오',
		sameDay: '당일',
		depositInstructions:
			'이 입금 지침은 케이맨 제도 거주자에게만 적용됩니다. 케이맨섬에서 송금하지 않는 경우 대체 은행을 이용하시기 바랍니다.',
		downloadInfo: '정보 다운로드',
		intermediaryBank: '중개은행 이름',
		intermediarySwift: '중개은행 SWIFT',
		beneficiarySwift: '예금주 SWIFT',
		beneficiaryBank: '예금주 은행',
		paymentProvider: '결제 제공업체 주소',
		accountHolder: '계좌 소유자 이름',
		virtualIban: 'Virtual IBAN',
		bic: 'BIC',
		createLiAcc: '라이브 계정 만들기',
		waitTitle: '새 탭 로딩 중',
		waitDescription:
			'이 창을 닫지 마십시오. 프로세스를 계속하려면 새 탭이 자동으로 열립니다. 계속 찾아보거나 그동안 여기에서 기다리실 수 있습니다.',
		depositTypeTitle: '입금 유형을 선택하세요',
		depositTypeDescription: '선호하는 입금 유형과 해당 결제 방법을 선택하세요.',
		typeCash: '현금결제',
		typeBankTransfer: '은행 송금',
		countryBankTitle: '결제수단',
		countryBankDescription: '결제 방법을 선택하세요',
		minimumAmount: '이 방법의 최소 금액',
		maximumAmount: '이 방법의 최대 금액',
		is: '이다',
		pleaseNote: '참고:',
		validateDeposit:
			'입금을 확인하려면, 이체가 완료된 후 거래소에 거래 영수증을 보내주십시오. 확인 후, 자금이 신속하게 거래 계좌에 추가되어 원활하고 효율적인 거래가 보장됩니다.',
		withdrawalchooseMatch:
			'앞으로 선택하실 출금 방식은 입금 방식과 일치해야 합니다.',
		notResponsibleDuringTransactions:
			'Tradeview는 거래 중 발생하는 환율 변동에 따른 손익에 대해 책임지지 않습니다.',
		minDeposit: '이 방법의 최소 입금 금액은 $100.00입니다.',
		cryptos: {
			comission: {
				title: '수수료: 있음',
				text: 'Tradeview는 입금 수수료를 부과하지 않습니다. 당사의 처리 업체에서 0.7%의 환전 수수료가 부과됩니다.',
			},
			scanText1: '거래소 앱의 스캔 기능을 사용하여 이 QR 코드를 스캔하거나, ',
			scanText2: ' 아래의 암호화폐 주소를 수동으로 복사하세요.',
			copyText:
				'아래 암호화폐 주소를 복사하여 거래 애플리케이션에 붙여넣으세요:',
		},
		processTimeSameDay: '당일 내',
		processTimethreeDay: '최대 3일',
		commisionYes: '예',
		commisionNo: '아니요',
		onReviewTitle: '입금 검토 중',
		onReviewText:
			'귀하의 입금이 현재 검토 중입니다. 입금 처리가 완료되면 저희 팀이 이메일을 통해 연락드리겠습니다.',
		bitPayFees: '암호화폐 처리업체는 다음 수수료를 부과합니다:',
		bitPayExchange:
			'교환수수료: 1.05%<br> 네트워크 수수료: 0.0003 BTC<br> 출금 수수료: 0.0003 BTC',
		minimumAndMaxiumAmountInterac: '최소 $75 CAD - 최대 $9,999 CAD',
		minumumAndMaxiumAdversInterac:
			'Interac는 최소 $75.00의 입금 기준을 적용합니다. $75.00 미만의 자금은 거부됩니다.',
		routingNumber: '라우팅 번호 (ABA)',
		beneficiaryBankAddress: '수취 은행 주소',
		beneficiaryAccountNumber: '수취인 계좌 번호',
		beneficiaryAccountName: '수취인 계좌 이름',
		paymentDetailsFFC: '지급 상세 FFC',
		iban: 'IBAN',
		swiftBic: 'SWIFT/BIC',
		currencies: '통화',
		sortCode: '소트 코드',
		entersortCode: '정렬 코드를 입력하십시오',
		beneficiary: '수취인',
		beneficiaryIBAN: '수취인 IBAN/계좌',
		cci: 'CCI',
		moreInformationTitle: '추가 정보 필요',
		moreInformationText:
			'예금 총액이 25,000달러 이상일 경우, 일회성 추가 확인이 필요합니다. 예금을 완료하려면 "계속"을 클릭하고 요청된 직업 및 재정 세부 정보를 제공하십시오.',
		moreInformationTextLTD:
			"일회성 추가 인증이 필요합니다. 입금을 완료하려면 '계속'을 클릭하고 요청된 고용 및 재무 정보를 제공하세요.",
		selectMethod: '카드결제업체',
		cryptoMena: '이 정보는 암호화폐 결제의 경우 한 번만 필요합니다.',
		noOptions: '사용 가능한 옵션이 없습니다',
		digitalWalletsDisclaimer:
			'• 손실은 초기 투자 금액을 초과할 수 있습니다.<br> • 제3자의 입금은 허용되지 않습니다. 모든 입금은 계좌 소유자가 해야 합니다.<br> • 거래 플랫폼의 화폐 단위는 미국 달러입니다.',
		continueWithMyExchangeApp: '내 환전 앱으로 계속하기',
		continueWithPayX: 'PAY X로 계속하기',
		orDepositDirectly: '또는 직접 입금:',
		maximumAmountPSE_COL: 'PSE 결제 수단의 경우 최대 금액은 600 USD입니다.',
		swiffyFooterInfo:
			'Tradeview Ltd.는 출금을 처리하는 대신 신용카드로 이루어진 예금을 반환/환불할 권리를 보유합니다.',
	},

	//Email
	email: {
		company: '회사 소식',
		selectOne: "트레이딩 뉴스(Surf's Up!)",
		selectTwo: "Surf's Up!",
		update: '업데이트',
		manageSubscription:
			'여기에서 구독을 관리하세요. 브랜드 뉴스레터를 받고 싶은 주제를 선택하세요',
		dontReceiveEmails:
			'위 주제에 대한 이메일을 더 이상 받지 않으려면 해당 항목을 선택 취소하세요. "업데이트" 버튼을 클릭하는 것을 잊지 마세요.',
	},

	//password
	password: {
		title: '비밀번호 변경',
		subTitle: '비밀번호를 변경하려면 이메일 계정으로 일회용 코드를 요청하세요.',
		request: '코드 요청하기',
		submit: '제출하기',
		code: '코드',
		current: '현재 비밀번호',
		confirm: '새 비밀번호 확인',
		setPasswordPreference: '계정 설정하기',
		mailingSubscriptions: {
			title: '메일링 구독',
			description:
				'여기에서 구독을 관리하세요. 받은 편지함이나 회사 정보로 직접 주요 통찰력과 분석을 받아 최신 상태를 유지하세요.',
			subscriptionUpdated: '구독정보가 업데이트되었습니다.',
			subscriptionError: '오류가 발생했습니다! 지원팀에 문의해 주세요.',
		},
		passwordSettings: {
			title: '비밀번호 설정',
			description:
				'계정 보안을 보장하기 위해 비밀번호 설정을 관리하세요. 여기에서는 원할 때마다 변경할 수 있습니다.',
		},
		factor2Verification: {
			title: '2단계 인증 설정',
			description:
				'이 프로토콜을 추가하여 계정 보안을 강화하세요. 로그인할 때마다 보안 코드를 요구하여 계정에 대한 무단 액세스를 방지하세요.',
			firstStepTitle: '1단계: 인증 앱 다운로드',
			firstStepFirstParagraph:
				'모바일 기기에 인증 앱을 다운로드하세요. Play Store나 App Store에서 Google Authenticator를 검색하세요.',
			firstStepSecondParagraph:
				'2단계 인증(2FA)을 활성화하는 경우 비밀번호와 인증 앱에 표시되는 코드를 입력해야 합니다.',
			turnOn: '켜기',
			secondStepTitle: '2단계: 인증 코드 입력',
			scanQRCode: '인증 앱을 사용하여 다음 QR 코드를 스캔하세요.',
			enterCodeManually: '인증앱에 표시된 6자리 코드를 입력하세요.',
			invalidCode: '입력한 코드가 잘못되었습니다. 다시 시도해 주세요.',
			authCompleted: '인증이 성공적으로 완료되었습니다.',
			disable: '비활성화 하기',
			succesfullyActivatedAuth:
				"인증 프로세스를 성공적으로 완료하였습니다. 이전 상태로 돌아가시려면 '비활성화' 버튼을 클릭하시면 됩니다.",
			deactivatedNotification: '2FA 인증이 비활성화되었습니다.',
			insertCode: '2FA 코드를 삽입하세요',
			downloadAuth: 'Google OTP 다운로드',
			enterAuthCode: '인증번호를 입력하세요',
			codeSuccess: '인증되었습니다.',
		},
		accountPreferences: '귀하의 계정 환경설정',
		changeYoutPassword: '비밀번호 변경',
		requestChangePassword:
			'비밀번호를 변경하려면 등록된 이메일로 원타임 코드를 요청해야 합니다.',
		requestCode: '코드 요청하기',
		didntGetIt: '못받으셨나요?',
		tryAgain: '다시 시도하세요',
		enter6DigitCode: '6자리 코드를 입력하세요. 예: 123456',
		enterValidOTP: '입력한 코드가 잘못되었습니다. 다시 시도해 주세요.',
		notYourCurrentPassword: ' 현재 비밀번호가 아닙니다.',
		passwordConditions:
			'비밀번호는 8자 이상이어야 하며 소문자, 대문자, 숫자, 특수문자가 각각 1개씩 이상 포함되어야 합니다.',
		passwordsDontMatch:
			'입력한 비밀번호가 일치하지 않습니다. 다시 한번 확인하신 후 다시 시도해 주세요.',
		newPassword: '새 비밀번호',
		confirmPassword: '비밀번호 확인',
		passwordSuccessfulyChanged:
			'귀하의 비밀번호가 성공적으로 업데이트되었습니다!',
		sampleEmail: '일회성 코드가  로 전송되었습니다.',
		cantResendCode: '지금은 코드를 다시 보낼 수 없습니다. 다시 시도해 주세요.',
		enterCurrentPassword: '현재 비밀번호를 입력하세요',
		enterNewPassword: '새 비밀번호를 입력하세요',
		enterConfirmNewPassword: '새 비밀번호를 확인하세요',
		passwordUpdated: '귀하의 비밀번호가 성공적으로 업데이트되었습니다!',
		successful2Factor: '2단계 인증이 성공적으로 완료되었습니다!',
		areYouSure: '2FA를 비활성화하시겠습니까?',
		changePasswordDescription:
			'계정 설정을 변경하고, 구독을 관리하고, 계정 보안을 유지하세요.',
	},

	//Contact
	contact: {
		requestCall: '전화요청하기',
		phoneNumber: '전화 번호',
		preferedTime: '선호하는 시간',
		selectPreferedTime: '원하는 통화 시간을 선택하세요.',
		enterPhone: '전화번호를 입력하세요',
		knowMore: '우리에 대해 더 많이 알아보세요',
		callSchedule: '통화가 예약되었습니다',
		callScheduleDescription:
			'상담원 중 한 명이 귀하의 통화에 배정되는 즉시 연락드리겠습니다. 이 통화는 요청 후 24시간 이내에 이루어지며 다음 근무일부터 시작됩니다.',
		contactUsErrorCall:
			'불편을 끼쳐드려 죄송합니다. 다시 시도하십시오. 문제가 계속되면 사용 가능한 다른 옵션을 사용하여 저희에게 연락해 주시기 바랍니다.',
		failedToSchedule: '통화를 예약할 수 없습니다.',
		weWillContactYou:
			'귀하가 선택한 시간 내에 서비스 담당자 중 한 명이 귀하에게 연락할 것입니다.',
		unableToContactYou:
			'안타깝게도 지금은 통화 일정을 잡을 수 없었습니다. 정보를 다시 확인하신 후 다시 시도해 주세요.',
		infoInvalid:
			'제공된 정보가 유효하지 않습니다. 검토한 후 다시 시도해 주세요.',
		inNeedOfHelp: '도움이 필요하신가요? 저희가 도와드리겠습니다!',
		inNeedOfHelpDescription:
			'요청에 대한 추가 업데이트를 원하시거나 계정에 대한 세부 정보를 확인해야 할 경우, 저희가 도와드리겠습니다! 언제든지 연락 주시면 도와드리겠습니다.',
		chatDescription: '채팅이 더 편하신가요?',
		chatDescription1:
			'트레이드뷰 상담원은 미국 근무일 기준 연중무휴 24시간 이용 가능합니다.',
		mailForward:
			'이메일로 문의사항을 보내주시면 최대한 빨리 답변해 드리겠습니다.',
		emailUs: '이메일을 보내주세요',
		letsChat: '채팅하기',
		scheduleACall: '통화 예약',
		contactDisclaimer: ' 번으로 전화하거나 ',
		orVia: ' 으로 이메일을 보내 직접 문의하실 수 있습니다.',
		contactDisclaimerLatam:
			'원하시면, 다음 이메일을 통해 직접 문의하실 수 있습니다:',
		stayConnected: '트레이드뷰와 연락을 유지하세요',
		timeZone: '시간대',
		selectTimeZone: '시간대를 선택하세요',
		customDate: '날짜와 시간을 선택하고 싶어요',
		soonAsPossible: '가능한 한 빨리',
		callWhen: '언제 전화하면 될까요?',
		contactHelper:
			"참고: 예정된 전화 통화는 영어로만 진행됩니다. '최대한 빨리' 옵션을 선택하시면 다음 영업일 24시간 이내에 연락드리겠습니다.",
		selectDate: '날짜를 선택하세요',
		selectTime: '시간을 선택하세요',
		selectOption: '선택하세요',
		preferredDate: '선호하는 날짜',
		sendEmail: '이메일을 보내주세요',
		subject: '제목',
		describeEmail: '문의사항을 입력하세요',
		concerns: '여기에 질문, 우려 사항 또는 의견을 적어주세요.',
		yourMessage: '고객님의 메시지',
		emailSuccessful:
			'귀하의 이메일이 성공적으로 전달되었습니다! 다음과 같이 연락드리겠습니다. 가능한 한 빨리.',
		emailSuccessfulTitle: '이메일 수신됨',
		emailErrorfulTitle: '이메일 전달 문제',
		emailErrorMessage:
			'불편을 끼쳐드려 죄송합니다. 다시 시도하십시오. 문제가 계속되면 사용 가능한 다른 옵션을 사용하여 저희에게 연락해 주시기 바랍니다.',
		japanNotice:
			'일본 표준 시간대의 경우 오후 10시부터 오전 12시까지 또는 오전 6시에만 통화가 가능합니다. 양해부탁드립니다.',
		messageError: '메시지는 900자를 초과할 수 없습니다.',
		messageErrorShort: '메시지 길이는 15자 이상이어야 합니다.',
		titleError: '제목은 60자를 초과할 수 없습니다.',
		titleErrorShort: '제목은 4자 이상이어야 합니다.',
		preferredDate: '선호하는 날짜',
		failedAttempt: '나중에 다시 시도해 주세요',
		callDate: '통화 스케줄이 확인되었습니다.',
		contactSetDate:
			'고객님께서 선택한 날짜와 시간에 당사 상담원 중 한 명이 연락드리겠습니다.',
		errorPhoneNumber: '전화번호에는 문자나 기호를 포함할 수 없습니다',
		callDescription:
			'상담원과 통화하고 싶으신가요?  편하신 시간으로 예약하세요! ',
	},

	//menu
	menu: {
		appli: '신청서',
		account: '계정',
		platforms: '다운로드',
		history: '내역',
		deposit: '입금',
		transfer: '계좌간 이체',
		withdraw: '출금',
		tradingTools: '거래 도구',
		settings: '설정',
		passwordsettings: '비밀번호 설정',
		emailsettings: '이메일 설정',
		authenticationsettings: '인증 설정',
		contactUs: '문의하기',
		accessDemo: '데모 계정에 접근',
		accessRestricted: '접근 제한됨',
		btnReSubmit: '문서 다시 제출',
		temporarilyUnavailable: '이 기능은 일시적으로 사용 불가입니다',
		sorryFeature:
			'죄송합니다만, 접근하려는 기능은 아직 이용할 수 없습니다. 신청 절차를 완료하고 계정이 설정되면 해당 기능을 이용하실 수 있습니다.',
		btnContinue: '계속',
		liveFeature: '이것은 실시간 계정 기능입니다',
		featureOnly:
			'접근하려는 기능은 실시간 계정에만 제공됩니다. 지금 실시간 계정을 만들어서 접근하세요.',
		call: '시간이 없으신가요? 저희 지원팀은 GMT 기준 24/5 전화로 대기 중입니다.',
		chat: '채팅을 선호하시나요? 그렇게 하겠습니다. 저희 에이전트는 미국 근무일에 24시간 대기 중입니다.',
		mail: '급하지 않으신가요? 이메일을 보내주시면 전문가가 답변 드리겠습니다.',
		call2: '전화 주세요',
		chat2: '채팅으로 이야기합시다',
	},

	//sidebar applications process
	sidebar: {
		help: '도움이 필요하신가요?',
		call: '전화로 문의하기',
		chat: '채팅으로 문의하기',
		mail: '우편으로 문의하기',
		notReady: '아직 실투자 준비가 되지 않으셨나요?',
		btnDemo: '데모 계정 만들기',
	},

	//form signature
	formSignature: {
		authorised: '승인된 고객 서명, 위에 서명',
		or: '또는',
		accept: '서명 확인',
		error1: '아직 서명하지 않으셨습니다. 서명해 주세요.',
		drop: '여기에 파일을 놓거나',
		browse: '먹다',
		make: '파일이 JPEG, PNG 또는 PDF 형식이고 크기가 3MB를 초과하지 않는지 확인하세요.',
		error_help:
			'서명이 포함된 파일을 업로드하지 않았습니다. 서명이 포함된 파일을 업로드하십시오.',
	},

	//Text of application process form
	applicationForm: {
		liveIndividual: ' 실거래 개인 계좌',
		liveJointAccount: '실거래 공동 계좌',
		primaryAccountHolder: '주 계좌 이용자',
		title: '인적정보',
		subtitlePlatform:
			'한번의 가입으로 트레이드뷰가 제공하는 모든 플랫폼을 이용하실 수 있습니다.',
		subtitleDocument: '신원 확인을 위해 어떤 유형의 문서를 사용하시겠습니까?',
		subtitleResidence: '거주 증명을 위해 어떤 유형의 서류를 사용하시겠습니까?',
		subtitleExperience:
			'귀하의 외환, 주식, 선물, 파생상품 또는 CFD 거래 경험을 가장 잘 나타내는 보기를 선택하세요.',
		submitContact: '문의하기',
		drop: '여기에 파일을 드롭하세요.',
		browse: '먹다',
		make: '파일 형식이 JPEG, JPG 또는 PNG이며 크기가 3MB를 초과하지 않도록 하세요.',
		makeMaxSize:
			'파일 형식이 JPEG, JPG 또는 PNG이며 크기가 15MB를 초과하지 않도록 하세요.',
		tryAgain: '다시 시도하세요',
		openFile: '파일 열기',
		submitted: '신청서 제출됨: 검토 진행 중',
		thankyou:
			'회원가입을 신청해주셔서 감사합니다. 귀하의 회원가입신청서는 현재 검토 중이며 곧 승인될 것입니다.',
		operations: '추가 문서가 필요한 경우 당사 팀에서 연락을 드릴 것입니다..',
		appreciate: '계속해서 업데이트해드리겠습니다.',
		gotocabinet: '내 캐비닛으로 이동',
		explore: 'Tradeview 살펴보기',
		acknowledgementText:
			'아래에 서명함으로써 본인은 이 프로세스의 이전 단계에 나열된 문서를 인정하고 이에 동의합니다.',
		acknowledgementTextLATAM:
			'동의 체크박스를 선택하고 서명하기 전에 이 페이지의 각 항목을 신중하게 검토하고 이해하십시오.',
		jointConsent:
			'동의란을 체크하고 서명하기 전에 이 페이지의 각 항목을 신중하게 검토하고 이해하세요.',
		secondaryAccount: '계좌 이용자2 추가',
		secondaryAccountDesc:
			'공동계좌를 신청하셨기 때문에 두번째 이용자를 추가합니다',
		primaryAccountHolder: '주 계좌 이용자:',
		secondaryAccountHolder: '두번째 계좌 이용자:',
		corporateResol: '기업 결의 (Corporate resolution)',
		corporateResolDisclaimer:
			'파일을 업로드하려면 파일을 필드에 놓거나 아이콘을 사용하여 찾아보세요.',
		corporateResolDisclaimer2:
			'파일 형식이 JPEG, JPG 또는 PNG이며 크기가 3MB를 초과하지 않도록 하세요.',
		corporateResolDesc:
			'{link}를 클릭하여 Tradeview의 표준 법인 결의서를 다운로드하고 작성하시거나, 직접 준비하신 서류를 제출하실 수 있습니다.',
		shareHolder: '주주 추가',
		shareHolderDesc:
			'각각 최소 10%의 지분을 보유한 최대 9명의 주주를 추가하면 되시고, 주주가 없는 법인의 경우 이 단계를 스킵하실 수 있습니다.',
		addShareholder: '새 주주 추가',
		or: '또는',
		completeShareholder: '주주의 정보를 완료하세요',
		shareholder: '주주',
		information: '정보',
		aboutToComplete: '주주 #{number}에 대한 정보를 완료하려고 합니다',
		noShareAvailable:
			'주주와 계정 보유자의 총 비율은 100%를 초과할 수 없습니다. 다시 시도해 주세요.',
		percentageLow:
			'주주와 계정 보유자의 총 비율은 100%여야 합니다. 확인해 주세요.',
		aboutToCompleteDesc:
			'시작하기 전에 주주 #{number}의 다음 서류를 준비하세요:',
		accountHolderDisclaimer:
			'회사의 {percentage} 이상의 지분을 보유한 주주에게는 개인 정보, 신분증 및 주소 증명을 요청합니다. {percentage} 미만의 지분을 보유한 주주에게는 이름과 성만 요청합니다.',
		deleteShareholder:
			'주식을 수정하거나 주주의 신분증 및 주소 증명을 업로드하려면 기존 항목을 삭제하고 다시 추가해야 합니다.',
		sendInvitation: '초대장 보내기',
		inviteSentSuccess: '초대장이 성공적으로 발송되었습니다',
		inviteSentSuccessDesc:
			'주주 정보 섹션에서 각 주주의 신청 진행 상황을 추적하세요.',
		primaryHolder: '계좌 보유자(귀하)',
		sharePercent:
			'주식은 회사의 소유권을 나타냅니다. 기업 구조에서 소유 지분을 정의하기 위해 주주에게 백분율을 할당합니다. .',
		accountHolder: '계좌 보유자(귀하)',
		shareHolderDetails: '주주 {user} 세부사항:',
		continueNoShareholder: '주주 없이 계속하기',
		infoSwitchOff:
			'귀하의 관할권에서 요구하는 경우 당사 백오피스 팀이 향후 귀하에게 이를 요청할 것입니다.',
		fileNotValid: '올바른 형식과 크기로 파일을 업로드해 주세요.',
		resolUpload:
			'파일의 정보와 이미지가 명확하고 이해하기 쉬운지 확인하세요. 현재 가지고 있는 서류를 자유롭게 업로드해주세요. 일부가 누락되더라도 걱정하지 않으셔도 됩니다. 요청 시 나중에 업로드하거나 따로 보내실 수 있습니다.',
		upDocument: '문서 업로드',
	},

	expiredDocument: {
		resubmit: '문서를 다시 제출하십시오',
		settingsDesc:
			'ID 및/또는 주소 증명서를 업데이트하여 원활한 거래를 계속하려면 여기를 통해 다시 제출하십시오.',
		resubmitDesc:
			'귀하의 인증 문서가 만료되었습니다. {days}일 내에 또는 지금 즉시 귀하의 설정에서 새 파일을 업로드하십시오. 그렇지 않으면 업데이트될 때까지 이체, 출금, 입금 기능을 사용할 수 없습니다.',
		idRefinitiv: '어떤 ID 인증 방법을 사용하시겠습니까?',
		idRefinitivDesc:
			'정부에서 발급한 ID로 신원을 업데이트하면 귀하의 계좌 보안과 신뢰성을 보장합니다.',
		idTooltip:
			'ID 인증을 완료할 방법을 선택하십시오. 휴대폰으로 QR 코드를 스캔하거나 컴퓨터에서 새 탭을 열 수 있습니다. 아래에서 선호하는 방법을 선택하십시오.',
		cancelModal: '정말 떠나시겠어요?',
		cancelModalDesc:
			'기억하십시오, 이 단계를 {days}일 내에 완료해야 합니다. 그렇지 않으면 요구된 문서가 업데이트될 때까지 출금, 입금, 이체 기능을 사용할 수 없습니다.',
		accessRestricted: '접근 제한',
		uploadDocs: '문서를 업로드하세요',
		resubmitDocs: '문서 다시 제출',
		restrictedID:
			'무작위 검사를 통해 제공하신 ID가 만료된 것을 확인했습니다. 계좌 보안을 위해 이체, 출금, 입금 기능이 일시적으로 차단되었습니다.',
		restrictedID2:
			'접근을 복구하고 원활한 거래를 계속하려면 지금 새 ID를 업로드하십시오.',
		restrictedPOA:
			'무작위 검사를 통해 제출하신 주소 증명서가 만료된 것을 확인했습니다. 계좌 보안을 위해 이체, 출금, 입금 기능이 일시적으로 차단되었습니다.',
		restrictedPOA2:
			'접근을 복구하고 원활한 거래를 계속하려면 지금 새 주소 증명서를 업로드하십시오.',
		restrictedBoth:
			'무작위 검사를 통해 제출하신 ID와 주소 증명서가 만료된 것을 확인했습니다. 계좌 보안을 위해 이체, 출금, 입금 기능이 일시적으로 차단되었습니다.',
		restrictedBoth2:
			'접근을 복구하고 원활한 거래를 계속하려면 지금 새 파일을 업로드하십시오.',
		restrictedLimited:
			'확인 서류가 누락되었습니다. 접근 권한을 얻으려면 업로드해 주세요. 그 전까지는 거래 계정이 제한됩니다.',
		confirmationLimited:
			'이 단계를 완료해 주시기 바랍니다. 완료하지 않을 경우, 서류가 업로드될 때까지 거래 계정이 비활성화된 상태로 유지됩니다.',
		alertExpiredDocsSuccess:
			'서류가 성공적으로 제출되었습니다. 현재 검토 중입니다. 추가 서류가 필요한 경우 팀에서 연락드릴 것입니다.',
		alertExpiredDocsError:
			'새 서류를 지금 또는 앞으로 {days}일 이내에 업로드해 주세요.',
		alertMissingDocsError: '거래 계정을 활성화하려면 서류를 업로드해 주세요.',
		submitDoc: '서류 제출',
		idverseD:
			'Submitting a government-issued ID ensures the security and legitimacy of your account.',
		idverseT:
			"Choose how you'd like to complete your ID verification. You can scan the QR code with your phone’s camera, send a link to your phone via SMS or continue on your current device.",
	},

	//Aplication Process refinitiv
	appliProcessIDverse: {
		QRdescription: '휴대폰 카메라를 사용하여 QR 코드를 스캔하십시오.',
		IDVerseTitle: '어떤 신원 확인 방법을 사용하시겠습니까?',
		IDVerseTitleLatam: '선호하는 신원 확인 방법을 선택하세요',
		IDVerseTitleManualDoc: '선호하는 신원 확인 방법을 선택하세요',
		IDVerseTitleManualDocTitle: '문서 유형을 선택하세요',
		IDVerseTitleManualDocDesc: '본인 인증에 사용할 문서 유형을 선택하세요:',
		IDVerseTitleManualDocMainDesc:
			'신원 확인 절차는 사기를 방지하고 당사 서비스를 책임감 있고 합법적으로 사용하는 것을 보장하는 데 필수적입니다. 협조해 주셔서 진심으로 감사합니다.',
		IDVerseDesc:
			'보다 원활한 진행을 위해, 아래 옵션 중 하나를 사용하여 휴대폰에서 이 단계를 완료하는 것을 권장합니다:',
		or: '또는',
		verifyOnNewTab: '현재 장치에서 계속 진행하십시오.',
		sendLinkSms: 'SMS로 링크 보내기',
		verifyPopupConfig:
			'브라우저의 팝업 차단기가 비활성화되어 있는지 확인해 주세요. 자세한 내용은',
		clickHere: '여기를 클릭하세요',
		alertDetail:
			'각 고유 링크로는 한 번만 인증 프로세스에 접근할 수 있습니다. 다시 접근하려면 페이지를 새로고침하고 원하는 인증 방법을 클릭해 주세요.',
		alertDetailMobile: `각 고유 링크로는 한 번만 인증 프로세스에 접근할 수 있습니다. 인증 절차를 완료하려면 페이지를 새로고침한 후 '내 신원 인증하기'를 클릭해 주세요. 이미 완료하셨다면, '계속하기'를 클릭해 주세요.`,
		//Modal Verify Identity
		modalVerifyTitle: '신원을 확인하십시오',
		btnVerifyID: '신분증 확인',
		modalVerifyDesc1: '진행하려면, ID 인증 절차를 완료해야 합니다.',
		modalVerifyDesc2:
			'이미 완료했는데도 계속 진행할 수 없는 경우 당사에 문의하십시오  가능한 한 빨리.',
		modalVerifyButton: '신원 확인 방법을 선택하세요',
		//Skip step
		modalSkipTitle: '이 단계를 건너뛰시겠습니까?',
		modalSkipDesc1:
			'이 단계를 일시적으로 건너뛰고 나중에 클라이언트 캐비닛에서 완료하거나, 지금 ID 확인 방법을 선택하여 프로세스를 완료할 수 있습니다.',
		modalSkipDesc2:
			'이 단계를 완료해야 거래 계정을 활성화할 수 있다는 점을 유의하시기 바랍니다.',
		btnVerifyAddress: '내 주소 확인',
		btnVerifyIdentity: '내 신원 확인',
		btnSkip: '내 신원 확인',
		modalSendSMSChangeNumberTitle: '새 휴대폰 번호 입력',
		modalSendSMSChangeNumberDesc:
			'신분 확인 링크를 SMS로 받을 휴대폰 번호를 입력하세요.',
		modalSendSMSChangeNumberButton: '보내기',
		modalSendSMSChangeNumberCancel: '취소',
		modalSendSMSChangeNumberCheck: '등록된 휴대폰 번호로 저장',
		modalSendLinkSMSFailedTitle: '오류가 발생했습니다',
		modalSendLinkSMSFailedDesc:
			'SMS로 링크를 보낼 수 없습니다. 번호를 확인하고 다시 시도하세요.',
		modalSendLinkSMSFailedButtonCancel: '취소',
		modalSendLinkSMSFailedButtonChangeNumber: '번호 변경',
		modalSendLinkSMSTitle: 'SMS로 링크 전송됨',
		modalSendLinkSMSDesc:
			'등록된 휴대폰 번호로 SMS를 통해 링크가 전송되었습니다. 휴대폰에서 링크를 열고 지시에 따라 신원 확인을 완료하세요.',
		modalSendLinkSMSButtonReSend: '다시 보내기',
		modalSendLinkSMSButtonOkay: '확인',
		clickHere: '여기를 클릭하세요',
		or: '또는',
		modalSendLinkSMSOptionalNumber: '다른 휴대폰 번호로 보내기',
		uploadCurrentDevice: '현재 기기에서 문서를 업로드합니다.',
		retryIn: '다시 시도하려면 다음까지 기다려주세요',
		chooseTooltip:
			'신원 확인을 완료할 방법을 선택하세요. 휴대폰으로 QR 코드를 스캔하거나, SMS로 링크를 보내거나, 현재 기기에서 계속할 수 있습니다.',
		sendToDifferentNumber: '다른 휴대폰 번호로 보내기',
		chromeInstructions: {
			step1: '설정으로 이동하세요',
			step2: '개인정보 및 보안 > 사이트 설정 > 팝업 및 리디렉션으로 이동하세요',
			step3: `'차단' 옵션을 비활성화하세요`,
		},
		safariInstructions: {
			step1: 'Safari > 환경설정으로 이동하세요',
			step2: '웹사이트 > 팝업 창을 선택하세요',
			step3: '필요한 설정을 조정하세요',
		},
		firefoxInstructions: {
			step1: '메뉴 아이콘을 클릭하세요',
			step2: '환경설정 > 개인정보 및 보안 > 권한으로 이동하세요',
			step3: '필요한 팝업 설정을 조정하세요',
		},
		assistanceText: `어려움을 겪으시면`,
		assistanceText2: `지원을 요청해 주세요.`,
	},

	//Application process CORPORATE form
	applicationFormCorporate: {
		liveCorporateAccount: '실거래 법인 계좌',

		//Company details
		companyDetailsTitle: '회사 세부정보',
		nameLabel: '회사명',
		namePlaceholder: '회사 이름을 입력하세요',
		businessTypeLabel: '사업유형',
		businessTypePlaceholder: '사업유형을 선택하세요',
		companyEmailLabel: '회사 이메일',
		companyEmailPlaceholder: '회사 이메일을 입력하세요',
		companyEmailTooltip:
			'안전한 커뮤니케이션을 보장하고 기업 계정의 적법성을 확인하기 위해 회사 이메일을 요청합니다. 이는 귀하의 비즈니스를 위해 안전하고 신뢰할 수 있는 거래 환경을 유지하는 데 도움이 됩니다.',
		businessDescriptionLabel: '사업설명',
		businessDescriptionPlaceholder:
			'회사 규모와 제공하는 서비스에 대한 간략한 설명을 입력하세요.',
		businessDescriptionTooltip:
			'이는 귀하 회사의 활동과 목적을 이해하는 데 도움이 됩니다. 명확한 설명을 제공하면 원활한 계정 승인 절차가 보장되고 귀하의 비즈니스 요구 사항에 맞게 서비스를 맞춤화하는 데 도움이 됩니다.',

		//Company address
		companyAddressTitle: '회사 주소',
		companyAddressTitleTooltip: `이는 귀하의 사업체가 위치한 국가를 나타냅니다. 정확한 정보는 지역 요구 사항 및 규정에 따라 서비스를 맞춤화하는 데 도움이 됩니다.  
		귀하의 거주 국가가 옵션에 나열되지 않은 경우, 귀하의 지역에서는 서비스를 제공할 수 없습니다.`,

		//Account ownership
		accountOwnershipTitle: '계정 소유권 정보',
		dateIncorporationLabel: '법인 설립일',
		dateIncorporationTooltip:
			'귀하의 회사가 공식적으로 등록된 날짜입니다. 이 날짜를 제공하면 귀하의 비즈니스의 법적 지위를 확인하고 규제 요건을 준수하는지 확인하는 데 도움이 됩니다.',
		countryOfRegistrationLabel: '설립 국가',
		countryOfRegistrationPlaceholder: '국가를 선택해주세요',
		countryOfRegistrationTooltip:
			'귀하의 회사가 공식적으로 등록된 국가입니다. 이 정보를 제공하면 귀하 비즈니스의 법적 관할권을 이해하고 지역 규정을 준수하는 데 도움이 됩니다.',
		marketCapitalizationLabel: '총 시가총액 또는 순자산',
		marketCapitalizationPlaceholder: '회사의 총 시가총액을 입력하세요.',
		marketCapitalizationTooltip:
			'총 시가 총액은 회사 발행 주식의 전체 시장 가치를 포함하는 반면, 순자산은 회사 자산에서 부채를 뺀 총 가치를 나타냅니다.',
		isSubsidiaryLabel: '자회사인 경우 모회사를 입력하세요.',
		isSubsidiaryPlaceholder: '모회사 이름을 입력하세요.',
		isIndividualRegularMemberLabel:
			'이 양식을 작성하는 개인은 정규 회원/파트너입니까, 아니면 이 관계에 언급된 법인의 최종 수혜자 소유자를 대표합니까?',

		//Tax residency information
		taxResidencyTitle: '세금 거주 신고',
		isUSCompanyLabel: '회사는 미국 법인 또는 미국 납세 거주자로 분류됩니까?',
		taxResidencyContryLabel:
			'회사는 세금 목적상 다음 국가의 거주자임을 확인합니다.',
		taxResidencyContryListLabel: '국가',
		taxResidencyContryListPlaceholder: '국가를 선택해주세요',
		taxResidencyReferenceCodeLabel: '주민등록번호',
		taxResidencyReferenceCodePlaceholder: '주민등록번호를 입력해주세요',
		modalRegulationP:
			'죄송합니다. 규제로 인해 미국 영토에 기반을 두고 있거나 세금 거주자로 간주되는 회사에게는 서비스를 제공할 수 없습니다.',

		//Account type and platform information
		accountTypeTitle: '계좌 유형',

		// Financial details
		financialDetailsTitle: '재무정보',
		financialDetailsTooltip:
			'귀하는 양 당사자(귀하와 Tradeview)의 위험을 적절하게 해결하기 위해 PEP 상태 또는 관련 연결을 공개해야 합니다. ',
		companyAnnualIncomeLabel: '회사의 연간 수입/총 매출액은 얼마입니까?',
		companyAnnualIncomeTooltip:
			'회사의 연간 소득 또는 총 매출액은 특정 기간(일반적으로 1년) 동안 조직이 창출한 총 수익을 나타냅니다..',
		companyTotalAssetsLabel: '귀하의 총 자산은 얼마입니까?',
		companyTotalAssetsTooltip: '자산의 가치는 저축, 투자, 부동산의 가치입니다.',
		companyLiquidAssetsLabel: '현재 자산잔액은 얼마입니까?',
		companyLiquidAssetsTooltip:
			'귀하의 유동 자산 잔액은 현금, 금전, 시장 상품 및 유가 증권의 합계입니다.',
		companyOriginAssetsLabel: '귀하의 총 자산은 얼마입니까?',
		companySourceFundsLabel: '회사의 예금/자금의 출처는 무엇입니까?',
		companyPruoseAccountLabel:
			'트레이드뷰 회원가입을 하시는 목적이 무엇입니까?',
		companyIsConnectedBanktruptcies: '회사가 파산한 적이 있나요?',
		companyIsConnectedBanktruptciesDetailsLabel: '파산 세부정보',
		companyIsConnectedBanktruptciesDetailsPlaceholder:
			'회사와 관련된 파산에 대한 정보를 포함합니다',
		companyIsConnectedBanktruptciesDetailsTooltip:
			'회사는 양측(회사와 Tradeview)의 리스크를 해결하기 위해 파산 관련 사항을 공개해야 합니다. 그러나, 회사가 파산과 관련이 있더라도 신청 절차를 계속 진행할 수 있다는 점을 안심해 주시기 바랍니다.',

		//Proof of address
		proofAddressTitle: '거주지 증명서',
		proofAddressTitleCorporate: '회사 주소 증명',
		proofAddressDescription:
			'규제 표준을 준수하는지 확인하려면 위치를 확인하세요.',

		//Company Account Consent
		companyAccountConsentTitle:
			'법인 세부정보를 공유해 주셔서 감사합니다. 계속해서 진행을 도와드리겠습니다!',
		companyAccountConsentDescription1:
			'이제 예금주 정보를 입력하셔야합니다. 제공된 세부정보는 언제든지 화면 오른쪽에 진행 목록에서 편집할 수 있습니다. 수정이 필요한 정보 옆에 있는 연필 아이콘을 클릭하세요.',
		companyAccountConsentDescription2:
			'정부가 발행한 사진이 부착된 신분증과 거주 증명서 외에, 필요한 문서를 업로드할 수 있습니다.',
		companyAccountConsentDocumentsTitle:
			'시작하기 전에 업로드할 문서가 준비되어 있는지 확인하세요.',
		companyAccountConsentDocumentsList1:
			'계정 소유자의 사진이 부착된 정부 발급 신분증',
		companyAccountConsentDocumentsList2: '계좌 소유자의 거주 증명서',
		applicationFormAccountCheck:
			'*Tradeview Financial Markets S.A.C.에 동의합니다. 신분증을 포함한 개인정보를 제공하여 전자적으로 본인의 신원을 확인합니다. 이 정보는 정확성을 확인하고 다른 신뢰할 수 있는 소스에서 보유하거나 획득한 데이터와 일치시키기 위해 신뢰할 수 있는 신원 확인 서비스 제공업체와 공유됩니다.',

		//Company Consent
		companyConsentTitle: '관심을 가져주셔서 감사합니다! 회원가입을 시작합니다.',
		companyConsentDescription:
			'법인 계좌를 개설하려면 귀하의 정보가 필요합니다.',
		companyConsentDocumentsTitle: '시작하기 전에 다음 문서를 준비해 주세요:',
		companyConsentDocumentsOfCompanyTitle: '회사',
		companyConsentDocumentsList1: '회사 등록 증명서',
		companyConsentDocumentsList2: '회사 주소 증명서',
		companyConsentDocumentsList3: '회사 은행 명세서',
		companyConsentDocumentsList4: '회사 재무제표',
		companyConsentDocumentsList5: '회사 세금 증명서',
		companyConsentDocumentsList6: '회사 소유 구조',
		companyConsentDocumentsList7: '회사 연례 보고서',
		companyConsentDocumentsOfAccountHolderTitle: '계좌 소유자',
		companyConsentDocumentsOfAccountHolderList1: '회사 사업 계획서',
		companyConsentDocumentsOfAccountHolderList2: '회사 사업 허가증',
		companyConsentDocumentsOfShareholderTitle: 'UBO/주주',
		companyConsentDocumentsOfShareholderList1: '회사 주주 계약서',
		companyConsentDocumentsOfShareholderList2: '회사 주주 증명서',
		companyConsentAdditionalInfoDescription:
			'현재 준비된 문서를 업로드할 수 있습니다. 시작하려면 주소 증명서와 신분증만 필요합니다. 다른 문서는 나중에 업로드하거나 이메일로 보낼 수 있습니다.',
		applicationFormConsentCheck:
			'*Tradeview Financial Markets S.A.C.에 동의합니다. 신분증을 포함한 개인정보를 제공하여 전자적으로 본인의 신원을 확인합니다. 이 정보는 정확성을 확인하고 다른 신뢰할 수 있는 소스에서 보유하거나 획득한 데이터와 일치시키기 위해 신뢰할 수 있는 신원 확인 서비스 제공업체와 공유됩니다.',

		//Account holder details
		accountHolderDetailsTitle: '법인계정 소유자 정보',
		accountHolderDetailsTooltip:
			'계정 소유자는 법인계정을 주로 관리하는 개인입니다. 이 사람은 거래를 실행하고, 계정 결정을 내리고, 주주를 추가하거나 제거할 권한을 갖습니다. 계정 소유자 세부 정보가 기업 활동의 주요 의사 결정자를 정확하게 나타내는지 확인하세요.',

		//Account holder address
		accountHolderAddressTitle: '계좌 소유자 주소',
		accountHolderAddressTooltip:
			'계정 소유자, 즉 법인 계정을 관리하는 개인의 거주지 또는 사업장 주소를 제공하세요. 이 정보는 회사 자체가 아닌 계정 소유자와 관련된 것입니다.',

		//Account holder tax residency declaration
		accountHolderTaxResidencyTooltip:
			'법인 계좌를 관리하는 개인인 계좌 소유자의 세금 거주 정보를 제공하세요. 이 정보는 회사 자체가 아닌 계정 소유자와 관련된 것입니다.',
		accountHolderTaxResidencyModalDescription:
			'죄송합니다. 규제으로 인해 미국 영토에 거주하는 고객분들에게는 서비스를 제공할 수 없습니다. ',

		//Account holder trading experience
		accountHolderTradingExperienceDescription:
			'귀하의 외환, 주식, 선물, 파생상품 또는 CFD 거래 경험을 가장 잘 나타내는 보기를 선택하세요.',

		//Shareholder consent
		shareholderConsentTitle: '계정 소유자 정보 입력이 완료되었습니다.',
		shareholderConsentDescription1:
			'이제 거의 끝났습니다. 주주정보만 입력하시면 됩니다.',
		shareholderConsentDescription2:
			'필요한 경우 화면 오른쪽에 있는 진행상황 목록을 사용하여 언제든지 이전에 제공된 세부 정보를 편집할 수 있습니다. 수정하려는 정보 옆에 있는 연필 아이콘을 클릭하기만 하면 됩니다.',
		shareholderConsentDescription3:
			'정부가 발행한 사진이 부착된 신분증과 거주 증명서 외에 필요한 문서를 업로드할 수 있습니다.',
		companyConsentConsentDocumentsTitle:
			'시작하기 전에 귀하 또는 주주가 다음 필수 문서를 준비했는지 확인하십시오:',
		companyConsentConsentDescription1:
			'거의 완료되었습니다! 프로세스를 완료하려면 주주 정보를 입력하십시오.',
		companyConsentConsentDescription2:
			'필요한 경우 오른쪽 열의 연필 아이콘을 클릭하여 이전에 입력한 세부 정보를 수정할 수 있습니다.',
		shareholderConsentDocumentsTitle:
			'시작하기 전에 각 주주는 다음 필수 서류를 준비해야 합니다.',
		shareholderConsentDocumentsList1: '주주의 사진이 부착된 정부 발행 신분증',
		shareholderConsentDocumentsList2: '주주의 거주지 증명서',
		shareholderConsentDocumentsList3: '디지털 서명',
		shareholderConsentCheck:
			'*Tradeview Financial Markets S.A.C.에 동의합니다. 신분증을 포함한 개인정보를 제공하여 전자적으로 본인의 신원을 확인합니다. 이 정보는 정확성을 확인하고 다른 신뢰할 수 있는 소스에서 보유하거나 획득한 데이터와 일치시키기 위해 신뢰할 수 있는 신원 확인 서비스 제공업체와 공유됩니다.',

		//Application Submition
		applicationSubmitionTitle: '신청서 제출',
		applicationSubmitionDescription1:
			'법인계좌 신청이 거의 완료되었습니다! 신청서 작성을 위한 노력에 감사드립니다.',

		applicationSubmitedTitle: '신청서 제출됨: 검토 진행 중',
		applicationSubmitedDescription1:
			'라이브 공동 계좌 신청서를 제출해 주셔서 감사합니다. 귀하의 회원가입신청서는 현재 검토 중이며 곧 승인될 것입니다. ',
		applicationSubmitedDescription2:
			'정보 입력 중에 요청된 문서를 업로드하지 않으면 운영 팀에서 연락드릴 것입니다.',
		//Global
		selectOption: '선택하세요',
		accountOwnershipTooltip:
			'이는 귀하의 사업체가 위치한 국가를 나타냅니다. 정확한 정보는 지역 요구 사항 및 규정에 따라 서비스를 맞춤화하는 데 도움이 됩니다. 귀하의 거주 국가가 옵션에 나열되지 않은 경우, 귀하의 지역에서는 서비스를 제공할 수 없습니다.',

		//Progress
		companyInformation: '회사 정보',
		companyAddressDetails: '회사 주소 세부사항',
		companyOwnershipDetails: '회사 소유 구조 세부사항',
		companyDocuments: '회사 문서',
		accountConsent: '계좌 동의',
		tradingExperience: ' 거래 경험',
		accountInformation: '계좌 정보',
		tradingExperience: ' 거래 경험',
		IDVerification: '신분증 확인',
		accSetupSubmision: '계정 설정 및 제출',
		shareholderInformation: '주주정보',
		shareholderConsent: '주주 동의',
		finish: '완료',
		addressDetails: '주소 세부사항',

		share: '공유',

		//Shareholder consent
		welcomeShareholderConsentTitle:
			'법인 계좌에 가입할 준비가 되셨나요? 신청을 시작해 보세요.',
		welcomeShareholderConsentDescription1:
			'법인 계좌를 개설하려면 귀하의 정보가 필요합니다.',
		shareholderConsentDocumentsTitle: '시작하기 전에 다음 문서를 준비하십시오.',
		welcomeShareholderConsentDocumentsList1: '사진이 부착된 정부 발행 신분증',
		welcomeShareholderConsentDocumentsList2: '거주지 증명서',
	},

	//disclaimer
	disclaimer: {
		secure1: '안전한',
		secure2: 'SSL 암호화',
		secure3: '',
		term: '이용약관',
		privacy: '개인 정보 보호 약관',
		aml: '자금세탁방지 약관',
		withdrawal: '출금 약관',
		refund: '환불 약관',
		risk: '리스크 공지',
		title: '부인 성명',
		default: {
			description:
				'The services and products offered by Tradeview Markets are not being offered within the United States (US) and not being oﬀered to US Persons, as defined under US law. The information on this website is not directed to residents of any country where FX and/or CFDs trading is restricted or prohibited by local laws or regulations. CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. Between 74% - 89% of retail investors’ accounts lose money when trading CFDs. You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money.',
		},
		ltd: {
			description:
				'Tradeview Financial Markets S.A.C.가 제공하는 서비스 및 제품은 미국 내에서 또는 미국 법률에 정의된 미국인에게 제공되지 않습니다. 이 웹사이트의 정보는 외환 및/또는 CFD 거래가 현지 법률이나 규정에 의해 제한되거나 금지된 국가의 거주자를 대상으로 하지 않습니다. CFD는 복잡한 상품이며 레버리지로 인해 빠르게 돈을 잃을 위험이 높습니다. 개인 투자자 계좌의 74% - 89%가 CFD 거래 시 손실을 입습니다. CFD의 작동 방식을 이해하고 있는지, 돈을 잃을 위험이 높은지 여부를 고려해야 합니다.',
		},
		latam: {
			description:
				'Tradeview Financial Markets S.A.C.에서 제공하는 서비스 및 제품 미국 법률에 정의된 대로 미국(US) 내에서 제공되지 않으며 미국인에게 제공되지 않습니다. 이 웹사이트의 정보는 FX 및/또는 CFD 거래가 현지 법률 또는 규정에 의해 제한되거나 금지된 국가의 거주자를 대상으로 하지 않습니다. CFD는 복잡한 상품이며 레버리지로 인해 빠르게 돈을 잃을 위험이 높습니다. 개인 투자자 계좌의 74% - 89%가 CFD 거래 시 손실을 입습니다. CFD의 작동 방식을 이해하고 있는지, 돈을 잃을 위험을 감수할 여유가 있는지 고려해야 합니다.',
		},
		mena: {
			description:
				'Tradeview Financial Markets S.A.C.에서 제공하는 서비스 및 제품 미국 법률에 정의된 대로 미국(US) 내에서 제공되지 않으며 미국인에게 제공되지 않습니다. 이 웹사이트의 정보는 FX 및/또는 CFD 거래가 현지 법률 또는 규정에 의해 제한되거나 금지된 국가의 거주자를 대상으로 하지 않습니다. CFD는 복잡한 상품이며 레버리지로 인해 빠르게 돈을 잃을 위험이 높습니다. 개인 투자자 계좌의 74% - 89%가 CFD 거래 시 손실을 입습니다. CFD의 작동 방식을 이해하고 있는지, 돈을 잃을 위험을 감수할 여유가 있는지 고려해야 합니다.',
		},
	},

	//modal
	modal: {
		error: '회원가입을 진행할 수 없습니다.',
		description:
			'죄송합니다. 규제으로 인해 미국 영토에 거주하는 고객분들에게는 서비스를 제공할 수 없습니다.',
		thank: 'Tradeview 가입에 관심을 가져주셔서 감사합니다.',
		btnRegulation: '규제 페이지 방문',
	},

	//tooltips
	tooltips: {
		signature1:
			'서명을 업로드할 방법을 선택하세요. 서명 업로드 기능을 사용하거나 대화형 도구를 사용하여 직접 서명을 그릴 수 있습니다. 아래에서 원하는 방법을 선택하세요.',
		sourceAccount: '자금이 인출될 계좌입니다.',
		sourceAccountTransfer: '자금을 보내는 계좌입니다.',
		currencyUSD: 'USD: 미국 달러',
		currencyEUR: 'EUR: 유로',
		currencyJYP: 'JPY: 일본 엔 ',
		currencyCAD: 'CAD: 캐나다 달러',
		currencyGBP: 'GBP: 영국 파운드',
		targetAccount: '이체된 자금을 받을 계좌입니다.',
		digitalWallets:
			'편의를 위해 다양한 전자지갑 옵션을 제공합니다. 선택하신 자금 조달 방법에 따라 수수료가 다를 수 있다는 점을 유의해 주세요.',
		wireTransfers:
			'은행송금을 하시려면 송금확인서 또는 영수증을 korean@tvmarkets.com으로 보내주셔야 계좌에 반영됩니다. ',
		cardTransfers:
			'신용 카드 입금은 Visa, Mastercard 및 Apple Pay를 사용할 수 있습니다. ',
		currencyUphold: `귀하의 계정에서 거래를 실행하는 기본 통화입니다. <br/>USD: 미국 달러 <br/>EUR: 유로 <br/>JPY: 일본 엔  <br/>CAD: 캐나다 달러`,
		currencyType: '통화는 계정에서 사용하게 될 기본 통화입니다. ',
		leverageTM:
			'레버리지를 사용하면 초기 자본이 허용하는 것보다 더 큰 포지션을 제어할 수 있으며 일반적으로 50:1 또는 100:1과 같은 비율로 표현되며 자신의 예금과 비교하여 제어할 수 있는 자산을 보여줍니다.',
		demoXleverage: 'X-레버리지: 1:400',
		demoILC: 'ILC: 1:200',
		demoStock: '주식: 1:1',
		notSureAccount:
			'어떤 계정 유형을 선택해야 할지 모르시나요? 여기에서 검토할 수 있습니다. ',
		ltd: {
			withdrawCurrency:
				'귀하의 계정에서 사용할 주요 통화 유형입니다. 이는 다음 약어로 표시됩니다.<br><br>USD: 미국 달러 <br> EUR: 유로  <br> GBP: 영국 파운드',
		},
		latam: {
			withdrawCurrency: '계좌에서 거래를 실행할 기본 통화입니다.',
		},
	},

	//register
	register: {
		goBack: '돌아가기',
		titleRegister: '계정 등록',
		AccountDesc:
			'저희 트레이딩 포털에 오신 것을 환영합니다! 데모 계정 또는 실거래 계정을 선택하여 트레이딩 여정을 시작하고 Tradeview의 차이를 경험하세요.',
		AccountChoose: '어떤 유형의 계정을 생성하시겠습니까?',
		dinamicDescLive:
			'아직 실거래 계정을 개설할 준비가 되지 않으셨나요? <spam>데모 계정을 생성하세요.</spam>',
		dinamicDescDemo:
			'실거래를 원하시나요? <spam>실거래 계정을 생성하세요.</spam>',
		getYour: '지금 거래를 시작하세요!',
		or: '또는 여기에서 등록하세요:',
		email: '이메일',
		secure: '비밀번호 만들기',
		confirmPassword: '비밀번호 확인',
		disclaimer:
			"면책조항:  계좌를 개설하기 전 이는 Tradeview Financial Markets S.A.C.의 의무입니다. ('Tradeview') 귀하 또는 귀하를 대신하여 거래하도록 지명된 사람이 CFD 및 관련 금융 상품에 필요한 지식과 경험을 갖고 있는지 확인합니다. AML 및 CFT 의무를 준수하는 것도 우리의 요구 사항입니다. 이와 관련하여 당사가 위의 의무를 완전히 준수할 수 있도록 본 신청서에 따라 요청된 대로 정확하고 완전하며 사실에 근거한 정보를 제공해 주시기 바랍니다. 이 정보를 바탕으로 우리는 금융 상품과 관련된 투자 서비스가 귀하에게 적합한지 여부를 적절하게 결정할 수 있습니다. 모든 섹션을 완료해야 합니다. 자세한 내용은 고객 계약을 참조하세요. 유럽 연합 거주자 대상: 아래 박스를 체크함으로써 귀하는 Tradeview 또는 Tradeview 관련 개인으로부터 계좌 개설을 권유받지 않았음을 확인합니다.",
		byTicking: '이 상자를 선택하면 위의 면책조항에 동의하는 것입니다.',
		getstarted: '다음',
		messageFooter1: '제공되는 서비스와 제품은 미국 내에서는 제공되지 않으며, ',
		messageFooter2:
			'미국 법에 따라 정의된 미국인에게도 제공되지 않습니다. 이 웹사이트의 정보는 FX 및/또는 CFD 거래가 현지 법률이나 규정에 의해 제한되거나 금지된 국가의 거주자를 대상으로 하지 않습니다. CFD는 복잡한 상품이며, 레버리지로 인해 빠르게 자금을 잃을 위험이 높습니다. CFD 거래 시 소매 투자자의 74% - 89%가 돈을 잃습니다. CFD가 어떻게 작동하는지 이해하고, 자금을 잃을 높은 위험을 감당할 수 있는지 고려해야 합니다. CFD 계정의 74-89%가 손실을 봅니다. 수수료에 관한 자세한 내용은 이 링크를 참조해 주세요',
		client: '클라이언트 대시보드',
		instructionstitle1: '시간과 노력을 절약하세요!',
		instructionstitle2: '회원님께 딱 맞는 플랫폼',
		instructionstitle3: '',
		options1f: '규제되고',
		options1l: '안전함',
		options2f: '맞춤형',
		options2l: '지원',
		options3f: '업계최고',
		options3l: '유동성',
		haveAccount: '이미 회원이신가요?',
		signUp: ' 로그인',
		newCode: '일회성 코드가  로 전송되었습니다.',
		tryEgain:
			'이용하실 수 있는 코드 재전송이 불가능합니다. 잠시 후 다시 시도해 주세요.',
		invalidEmail: '형식이 잘못되었습니다. 다시 시도해 주세요..',
		passwordRequired: '이 필드는 필수입니다. 입력해주세요.',
		invalidPassword:
			'비밀번호는 8자 이상이어야 하며 소문자, 대문자, 숫자, 특수문자가 각각 1개씩 이상 포함되어야 합니다.',
		confirmPasswordRequired: '이 필드는 필수입니다. 입력해주세요.',
		passwordsDoNotMatch: '비밀번호가 일치하지 않습니다. 다시 시도해 주세요',
		errorDisclaimer: '진행하려면 확인란에 체크해 주세요.',
		firstNameError: '이 필드는 필수입니다. 입력해주세요.',
		typeAccountError: '계좌 유형을 선택해 주세요',
		invalidName:
			'이름에는 숫자나 기호가 포함될 수 없습니다. 다시 시도해 주세요.',
		invalidLastName:
			'성에는 숫자나 기호가 포함될 수 없습니다. 다시 시도해 주세요.',
		mfaCode: 'MFA 코드를 입력하세요',
		startDemo: '지금 무료 데모 계정을 받으세요!',
		orRegister: '또는 여기에서 등록하세요:',
		verificationCode: '인증코드',
		didntCode: '코드를 받지 못하셨나요? ',
		yourEmail: '귀하의 이메일',
		firstName: '이름',
		lastName: '성',
		accountType: '계좌 유형',
		accountCategory: '계정 카테고리:',
		accountCategoryPlaceholder: '계정 카테고리를 선택하세요',
		accountCategoryTooltip: `<strong>개인 계정:</strong>  </br> 개인 계정인 경우 이 옵션을 선택하세요. 단일 계좌 보유자. </br></br> <strong>공동 계좌:</strong>  </br> 배우자나 비즈니스 파트너 등 다른 사람과 계좌를 개설하는 경우 이 옵션을 선택하세요.  </br></br> <strong>기업 계정: </strong> </br> 법인을 대표하는 경우 이 옵션을 선택하세요. 사업이나 조직.  `,
		entity: '법인:',
		entityPLaceholder: '법인을 선택하세요',
		entityTooltip:
			'우리는 사업을 운영하는 모든 관할권에서 엄격한 금융 기준을 따릅니다. 자세한 내용은 여기에서 알아보세요.',
		countryTooltip:
			'如果您的居住国家不在选项中，很遗憾我们无法在您的位置提供服务。',
		checkRegis:
			'이 상자를 체크함으로써, Tradeview 또는 Tradeview와 관련된 개인으로부터 기관 변경을 권유받지 않았음을 확인합니다.',
		changeRegion: '내 지역의 법인으로 변경',
		liveIndividual: '실거래 개인 계정 </br> 지금 바로 거래를 시작하세요!',
		jointIndividual: '실거래 공동 계정 </br> 지금 바로 거래를 시작하세요!',
		corporateIndividual: '실거래 법인 계정 </br> 지금 바로 거래를 시작하세요!',
		entityText:
			'귀하는 현재 거주 국가와 다른 지역에 설립되고 규제된 기관을 선택하여 계좌를 생성하려고 합니다.',
		entity: '법인:',
		entityPLaceholder: '법인을 선택하세요',
		entityTooltip:
			'우리는 사업을 운영하는 모든 관할권에서 엄격한 금융 기준을 따릅니다. 자세한 내용은 여기에서 알아보세요.',
		accountRegis: '중요 공지',
		entityTextEu: `현재 방문 중인 웹사이트는 유럽 연합 내에 설립되지 않았거나 유럽 연합 국가 당국에 의해 규제되지 않는 기관에 의해 운영됩니다.  <br><br>  ‘계속하기’를 클릭하면 Tradeview 또는 Tradeview와 관련된 개인으로부터 기관 변경을 권유받지 않았음을 확인하는 것입니다. <br><br> 유럽 연합 규제 기관인 Tradeview Europe Ltd.로 이동하려면 ‘내 지역의 기관으로 변경하기’를 클릭하세요. Tradeview Europe Ltd.는 귀하의 관할권에 적합한 MFSA에 의해 규제됩니다.`,
		entitiesTitle: '국제 기관의 브랜드 하에 거래:',
		entitiesDesc: `<ul> <li> <b>Tradeview Ltd. (CIMA)</b> </li> </ul> <p>케이맨 제도 금융청(CIMA)에 의해 규제되며, 케이맨 제도 법(SIBL) 하에서 운영됩니다. (SIBL)</p>  <br> <ul> <li> <b>Tradeview Financial Markets S.A.C. (페루, 일본, MENA)</b> </li> </ul> <p>SUNARP에 등록되어 있으며, 페루의 일반 기업법(LGS) 하에서 운영됩니다.</p> `,

		entitiesDescEu: `<ul> <li> <b>Tradeview Ltd. (CIMA)</b> </li> </ul> <p>케이맨 제도 금융청(CIMA)에 의해 규제되며, 케이맨 제도 법(SIBL) 하에서 운영됩니다.</p>  <br> <ul> <li> <b>Tradeview Financial Markets S.A.C. (페루, 일본, MENA)</b> </li> </ul> <p>SUNARP에 등록되어 있으며, 페루의 일반 기업법(LGS) 하에서 운영됩니다.</p> <br> <ul> <li> <b>TVM Global Ltd.</b> </li> </ul> <p>라부안 금융 서비스 기관(FSA)에 의해 규제되며, 라부안 법에 따라 라이선스를 보유하고 있습니다.</p> `,
		individual: '개인',
		joint: '공동',
		corporate: '법인',
		reloadPage:
			'페이지를 새로고침하여 계속 진행하세요. 이렇게 하면 데이터 입력을 방해하는 문제가 해결됩니다.',
		instructionsIB1:
			'중개 사업을 성장시키세요! 5분 이내에 저희와 파트너가 되세요',
		instructionsIB2: '',
		instructionsIB3: '',
		titleIbRegister: 'Tradeview Markets를 처음 이용하시나요? ',
		disclaimerIBportal:
			"면책조항:  계좌를 개설하기 전 이는 Tradeview Financial Markets S.A.C.의 의무입니다. ('Tradeview') 귀하 또는 귀하를 대신하여 거래하도록 지명된 사람이 CFD 및 관련 금융 상품에 필요한 지식과 경험을 갖고 있는지 확인합니다. AML 및 CFT 의무를 준수하는 것도 우리의 요구 사항입니다. 이와 관련하여 당사가 위의 의무를 완전히 준수할 수 있도록 본 신청서에 따라 요청된 대로 정확하고 완전하며 사실에 근거한 정보를 제공해 주시기 바랍니다. 이 정보를 바탕으로 우리는 금융 상품과 관련된 투자 서비스가 귀하에게 적합한지 여부를 적절하게 결정할 수 있습니다. 모든 섹션을 완료해야 합니다. 자세한 내용은 고객 계약을 참조하세요.",
		alreadyClient:
			'이미 Tradeview 고객이신가요? 클라이언트 캐비넷에 로그인하여 IB로 등록하세요.',
		loginClientCabinet: '',
		registerIB: '',
		instructionsIBportal1: '저희가 도와드리겠습니다!',
		instructionsIBportal2: '모든 사람을 위한 솔루션',
		instructionsIBportal3: '다음이 필요합니다.',
		options1f_ib_portal: '턴키 클라이언트',
		options1l_ib_portal: '솔루션',
		options2f_ib_portal: '고객 지원',
		options2l_ib_portal: '24/5 이용 가능',
		options3f_ib_portal: '리베이트 일일 지급액',
		options3l_ib_portal: '및 수수료',
		register_enjoy: '지금 등록하고 다음 혜택을 누리세요:',
		fast_onboarding: '빠른 가입 절차',
		no_program: '사전 비용 없는 프로그램',
		fast_solutions: '고객 맞춤형 솔루션',
	},

	'reset-password': {
		instructionstitle1: '시간과 노력을 절약하세요!',
		instructionstitle2: '회원님께 딱 맞는 플랫폼',
		instructionstitle3: '',
		title: '새로운 비밀번호를 설정하세요',
		label1: '새 비밀번호',
		label2: '비밀번호 확인',
		options1f: '규제되고',
		options1l: '안전함',
		options2f: '맞춤형',
		options2l: '지원',
		options3f: '업계최고',
		options3l: '유동성',
	},

	//Calendar
	calendar: {
		title: '달력',
	},

	//application process
	application: {
		optional: '(オプション)',
		ifApplicable: '(해당되는 경우)',
		jobTitleL: '직책',
		jobTitleP: '직책을 입력하세요',
		emplymentAditionalDetails: '추가 정보',
		optional: '(선택사항)',
		taxResTitle: '세금 거주 신고',
		taxResPurposes: '납세의무가 있는 미국 시민 또는 미국 거주자입니까?',
		taxLabelCompany: '회사는 세금 목적으로 다음 국가의 거주자임을 확인합니다:',
		taxLabelIndividual:
			'본인은 세금 목적으로 다음 국가의 거주자임을 확인합니다:',
		taxResHereby: '나는 세금 목적상 다음 국가의 거주자임을 확인합니다.',
		taxResCountryL: '국가',
		taxResCountryP: '국가를 선택해주세요',
		taxResMarketL: '주민등록번호',
		jobTitleL: '직함',
		jobTitleP: '직함을 입력하세요',
		taxResMarketP: '주민등록번호를 입력해주세요',
		taxResMarketTM:
			'귀하의 투자를 보호하려면 주민등록번호가 필요합니다. 귀하의 정보는 당사에 의해 안전하게 보호되므로 안심하십시오. 우리는 OECD 보고 기준에 따라 이 정보를 요청할 의무가 있습니다. 여기에서 자세한 내용을 알아볼 수 있습니다.',
		taxResPoliticalL:
			'귀하는 정치적으로 노출된 사람(PEP), 가까운 친척 또는 PEP의 동료입니까?',
		taxResPoliticalTM:
			'PEP(정치적으로 노출된 사람)는 재정적 위험 평가에 잠재적인 영향을 미칠 수 있는 저명한 공직을 보유하고 있거나 보유해 온 사람을 뜻합니다.',
		taxResStatusL: '귀하의 PEP 상태는 무엇이며 PEP와 어떤 관련이 있습니까?',
		taxResStatusP:
			'귀하의 PEP 상태 또는 관계에 대한 세부 정보를 제공해 주십시오.',
		taxResStatusTM:
			'귀하는 양 당사자(귀하와 Tradeview)의 위험을 적절하게 해결하기 위해 PEP 상태 또는 관련 연결을 공개해야 합니다. 그럼에도 불구하고 귀하가 PEP이거나 PEP와 관련이 있는 경우에도 신청 절차를 계속 진행하실 수 있으니 안심하시기 바랍니다.',
		taxCode: '세금 참조 코드',
		taxCodeTooltip: `세금 참조 코드는 문자와 숫자의 조합으로 구성될 수 있으며, 완전히 숫자로만 이루어질 수도 있습니다. 귀하의 정보는 안전하게 보호됩니다. 우리는 OECD 보고 기준에 따라 이 정보를 수집해야 합니다. 자세한 내용은 <a href="https://www.oecd.org/tax/automatic-exchange/common-reporting-standard/" target="_blank" rel="noopener noreferrer">여기</a>에서 확인할 수 있습니다.`,
		selectTaxCode: '세금 참조 코드를 입력하세요',
		accountTypeH: '계좌종류',
		accountTypeD:
			'한번의 가입으로 트레이드뷰가 제공하는 모든 플랫폼을 이용하실 수 있습니다.',
		tradingMarketL: '거래시장',
		tradingMarketP: '시장 선택',
		tradingMarketTM:
			'거래시장은 자산이나 상품이 거래를 위해 상장되거나 호가되는 시장입니다. <br><br> 어떤 거래시장를 선택해야 할지 모르시나요? 여기에서 둘러보세요.',
		currencyTypeL: '통화 유형',
		currencyTypeP: '통화 종류를 선택하세요',
		currencyTypeTM:
			'통화는 계정에서 사용하게 될 기본 통화입니다. 이는 다음 약어를 사용하여 표시됩니다:<br><br>USD: 미국 달러 <br>EUR: 유로 <br> JPY: 일본 엔 <br> CAD: 캐나다 달러 ',
		platformL: '플랫폼',
		platformP: '플랫폼을 선택하세요',
		platformTM:
			'플랫폼은 자산이나 도구를 운영하기 위해 제공되는 소프트웨어 시스템입니다. <br><br> 어떤 플랫폼을 선택할지 고민중이신가요? 여기에서 검토하실 수 있습니다.',
		accountTypeL: '계좌 유형',
		accountTypeP: '계정 유형 선택',
		accountTypeTM:
			'계좌 유형을 통해 귀하의 계좌에서 사용할 수 있는 레버리지를 선택할 수 있습니다. <br><br> X-레버리지: 1:400<br> ILC: 1:200<br> 주식: 1:1 <br><br> 어떤 계정 유형을 선택해야 할지 모르시나요? 여기에서 검토할 수 있습니다.',
		emplymentDetailsH: '채용 내용',
		employmentStatusL: '고용상태',
		employmentStatusP: '고용상태를 선택하세요',
		employerL: '고용주',
		employerP: '고용주명을 입력하세요',
		occupationL: '직업',
		occupationP: '직업을 입력하세요',
		industryL: '업종',
		industryP: '업종을 선택하세요',
		industryTM:
			'업종은 귀하가 고용된 회사의 기본적인 특성과 활동을 설명합니다.',
		employmentTypeL: '고용상태',
		employmentTypeP: '고용상태를 선택하세요',
		employmentTypeTM:
			'고용상태는 귀하의 업무 방식이나 직업 상태를 정의하는 기본적인 특성과 조건을 설명합니다.',
		employmentAddressL: '고용주 주소',
		employmentAddressP: '고용주 주소를 입력하세요',
		employerCountryL: '고용주 국가',
		employerCountryP: '국가를 선택해주세요',
		employerProvinceL: '고용주 주/도',
		employerProvinceP: '주/도를 선택하세요',
		employerCityL: '고용주 시',
		employerCityP: '도시를 선택하세요',
		employerZipL: '고용주 우편번호',
		employerZipP: '고용주 우편번호를 선택하세요',
		businessTypeL: '사업유형',
		businessTypeP: '사업유형을 선택하세요',
		businessTypeTM:
			'사업유형은 조직이나 기업이 비즈니스 세계에서 운영할 때 취할 수 있는 다양한 법적 구조와 형태를 의미합니다.',
		businessCountryL: '사업 국가',
		businessCountryP: '국가를 선택해주세요',
		businessProvinceL: '사업 주/도',
		businessProvinceP: '주/도를 선택하세요',
		businessCityL: '사업 시',
		businessCityP: '도시를 선택하세요',
		businessLocationL: '사업자 주소',
		businessLocationP: '사업자 주소를 입력하세요',
		businessNameL: '사업자명',
		businessNameP: '사업자명을 입력하세요',
		businessWebL: '회사 홈페이지',
		businessWebP: '회사 홈페이지 URL을 입력하세요',
		businessIndustryL: '업종',
		businessIndustryP: '업종을 선택하세요',
		businessIndustryTM:
			'업종은 귀하가 고용된 회사의 기본적인 특성과 활동을 설명합니다.',
		financialDetailsH: '재무 세부정보',
		annualIncomeL: '귀하의 연간 수입은 얼마입니까?',
		totalAssetsL: '귀하의 총 자산 잔고는 얼마입니까?',
		totalAssetsTM:
			'귀하의 자산 잔액은 약정 금액을 공제한 후 저축, 투자, 부동산 자산의 가치입니다.',
		liquidAssetsL: '귀하의 유동자산 잔액은 얼마입니까?',
		liquidAssetsTM:
			'귀하의 유동 자산 잔액은 현금, 금전, 시장 상품 및 유가 증권의 합계입니다.',
		tradeAnnuallyL: '연간 얼마만큼 투자/거래할 계획입니까?',
		originAssetsL: '귀하의 총자산의 출처는 어디입니까?',
		originDepositsL: '예금/자금의 출처/출처는 무엇입니까?',
		purposeAccountL: '트레이드뷰 회원가입을 하시는 목적이 무엇입니까?',
		bankruptciesDetailsL: '파산 세부정보',
		bankruptciesDetailsP: '귀하와 관련된 파산에 대한 정보를 추가하세요.',
		bankruptciesDetailsTM:
			'귀하는 양 당사자(귀하와 Tradeview)의 위험을 해결하기 위해 파산 관계를 공개해야 합니다. <br><br> 그럼에도 불구하고 파산에 연루된 경우에도 신청 절차를 계속 진행하실 수 있으니 안심하시기 바랍니다.',
		bankruptciesConnetL: '파산신청을 하신적이 있으신가요?',
		tradingExperienceH: '거래 경험',
		tradingExperienceD:
			'귀하의 외환, 주식, 선물, 파생상품 또는 CFD 거래 경험을 가장 잘 나타내는 보기를 선택하세요.',
		tradingExperienceDMENA:
			'외환, 주식, 파생상품 또는 CFD 거래 경험을 가장 잘 나타내는 옵션을 선택하세요.',
		tradingExperienceTM:
			'귀하의 거래경험에 상관없이 맞춤형 지원, 지침 및 최적의 거래 경험을 제공하는 데 도움이 되도록 귀하의 거래 경험에 대해 답변해 주시기 바랍니다.',
		yearsTradingL: '몇 년 동안 거래하셨나요?',
		yearsTradingP: '선택하세요',
		tradingVolumenL: '귀하의 거래량은 얼마나 됩니까?',
		tradingVolumenP: '선택하세요',
		oftenTradeL: '얼마나 자주 거래합니까?',
		oftenTradeP: '선택하세요',
		identityH: '본인확인',
		identityDesc: '인증을 완료하려면 다음 문서 중 하나가 필요합니다:',
		identityD:
			'이 단계는 필수입니다. 더 원활한 경험을 위해 아래의 QR 코드를 사용하여 모바일 장치에서 완료하는 것을 권장합니다.',
		identityDLatam:
			'더 원활한 경험을 위해 아래 QR 코드를 사용하여 휴대폰에서 이 단계를 완료하시는 것을 권장드립니다.인증을 위해 다음 문서 중 하나가 필요합니다:',
		idDocumentL: '신분증',
		idDocumentP: '문서 유형을 선택하세요',
		idDocumentTM:
			'문서 유형은 안전한 거래 경험을 위해 신원을 확인할 수 있는 ID 유형을 의미합니다. 다음을 수락합니다:: <br> <br> 여권 (Suggested)<br> 신분증<br> 거주 허가증<br> 운전 면허증',
		idDocumentUploadL: '문서 업로드 ',
		idDocumentUploadTM:
			'파일의 정보와 이미지가 명확하고 이해하기 쉬운지 확인하세요.',
		idDocumentFrontL: '앞면',
		idDocumentFrontTM:
			'신분증 앞면에는 사진, 전체 이름 및 ID 번호가 표시됩니다.',
		idDocumentBackL: '뒷면',
		idDocumentBackTM:
			'신분증 뒷면에는 주소 및 기타 관련 정보와 같은 추가 정보가 포함되어 있습니다.',
		proofResidenceH: '거주지 증명서',
		proofResidenceHYour: '귀하의 거주 증명',
		proofResidenceD: '규제 표준을 준수하는지 확인하려면 위치를 확인하세요.',
		proofResidenceL: '거주지 증명서',
		proofResidenceP: '문서 유형을 선택하세요',
		proofResidenceTM:
			'주소를 확인하려면 다음 문서 중 하나를 제출하세요: <br><br>  • 공과금 청구서  <br>  • 은행 잔고증명서 <br> • 주민등록등본    <br><br>   허용되는 청구서에는 다음이 포함됩니다:    <br>• 가스    <br>• 전기  <br>  • 수도  <br>  • 유선전화  <br>  • 인터넷(거주지에 연결된 경우)  <br>  • 케이블(거주지에 연결된 경우)  <br><br>    휴대폰 요금 청구서나 고액 현금 입금액이 표시된 은행 명세서는 접수되지 않습니다.',
		proofUploadL: '문서 업로드 ',
		proofUploadTM:
			'올바른 거주지증명서류를 첨부하셨는지 확인해주세요: <br><br> • 발급일로 부터 3개월 이내 <br>• 귀하의 이름 명시 <br>• 신청서에 기재된 주소와 일치하는 주소 <br>• 짤린부분이 없는지 확인 <br>• 차단/마스크된 정보가 없는지 확인 <br>• 번역 가능한 언어인지 확인 <br>• 번역 가능한 언어가 있습니다',
		addressDetail: '주소',
		financialDetailsTM:
			'귀하는 양 당사자(귀하와 Tradeview)의 위험을 적절하게 해결하기 위해 재무 세부 정보를 공개해야 합니다.',
		acknowledgementH: '승인',
		acknowledgementCheck:
			'이 박스를 체크함으로써, 위에 나열된 문서에 포함된 모든 정보를 읽었고, 이해하였으며, 동의함을 확인합니다.',
		signatureH: '서명',
		signatureP1:
			'아래에 서명함으로써 본인은 이 프로세스의 이전 단계에 나열된 문서를 인정하고 이에 동의합니다.',
		signatureP2:
			'또한, 나는 위증 시 처벌을 받는다는 조건 하에, 신청서에 제공된 모든 정보가 사실이고 정확하며, 출처, 통화 유형 또는 입금 방법에 관계없이 내 계좌에 입금된 모든 금액이 귀하의 수익금이 아님을 인정하고 이에 동의합니다. 범죄 또는 불법 활동이며 합법적인 출처에서 파생됩니다.',
		signatureMethod: '어떤 서명 방법을 사용하시겠습니까?',
		signatureDraw: '서명하기',
		signatureUpload: '서명 업로드',
		signatureTM:
			'서명을 업로드할 방법을 선택하세요. 서명 업로드 기능을 사용하거나 대화형 도구를 사용하여 직접 서명을 그릴 수 있습니다. 아래에서 원하는 방법을 선택하세요.',
		signatureAD: '승인된 고객 서명, 위에 서명',
		additionalRiskH: '추가 리스크 공지',
		additionalRiskD1:
			'귀하의 계좌 신청서에 제공된 정보는 귀하가 다음 이유 중 하나로 인해 거래 계좌 개설에 대한 Tradeview Financial Markets S.A.C. 지침을 충족하지 않음을 나타냅니다.',
		additionalRiskUl1: '귀하는 21세에서 63세 사이가 아닙니다.',
		additionalRiskUl2: '연간 소득이 $25,000 USD 미만입니다.',
		additionalRiskUl3: '지난 1년 이내에 파산 신청을 한 경우',
		additionalRiskUl4: '현재 무직입니다.',
		additionalRiskD2:
			'Tradeview Financial Markets S.A.C.가 귀하의 계좌 개설을 준비하는 동안 귀하에게 이 투자를 재고하도록 조언할 필요가 있습니다. 귀하의 개인 정보 및/또는 투자 경험에 따라 외환은 투자 전략에 있어 너무 위험할 수 있습니다. 외환 거래로 인한 손실은 상당할 수 있습니다. 따라서 귀하는 귀하의 상황과 재정 자원을 고려하여 그러한 거래가 귀하에게 적합한지 신중하게 고려해야 합니다. 적은 증거금 요건으로 인해 외환 거래에서 얻을 수 있는 높은 수준의 레버리지는 귀하뿐만 아니라 귀하에게도 불리하게 작용할 수 있습니다. 레버리지를 사용하면 큰 손실과 이익을 동시에 얻을 수 있습니다.',
		additionalRiskChk1:
			'나는 Tradeview Financial Markets S.A.C.에서 정한 계좌 개설을 위한 최소 지침을 충족하지 못한다는 것을 이해합니다. 위의 단락에서. 그러나 개인사정을 고려하여 외환거래에 따른 금전적 위험을 고려하여 계좌개설을 진행하고자 합니다.',
		additionalRiskChk2:
			'나는 위의 내용을 읽었으며 여기에 제공된 정보를 완전히 이해했음을 인정합니다.',
		additionalRiskChk1Latam:
			'저는 제 거래 계좌와 관련된 고유한 위험을 인지하고 있으며, 투자 손실의 모든 가능한 결과를 고려했습니다. 외환 거래와 관련된 위험을 읽었으며, 계좌 개설 절차를 진행할 의사가 있습니다.',
		additionalRiskChk2Latam:
			'위의 내용을 읽고 여기 제공된 정보를 완전히 이해했음을 확인합니다.',
		submitApplicationH: '신청서 제출',
		submitApplicationD1:
			'거의 다 왔어요! 신청서를 작성하는 데 노력해 주셔서 감사합니다.',
		submitApplicationD2: '준비가 되면 아래 제출 버튼을 클릭하여 보내주십시오. ',
		submitApplicationD3:
			' 질문이 있거나 도움이 필요하시면 주저하지 말고 저희에게 연락해 주십시오.',
		submitApplicationLink: '문의하기.',
		submitApplicationCheck:
			'나/우리는 마케팅 배포 목록에 포함되는 데 동의합니다.',
		applicationSubmitedH: '신청서 제출됨: 검토 진행 중',
		applicationSubmitedD1:
			'회원가입을 신청해주셔서 감사합니다. 귀하의 회원가입신청서는 현재 검토 중이며 곧 승인될 것입니다.',
		applicationSubmitedD2:
			'추가 문서가 필요한 경우 당사 팀에서 연락을 드릴 것입니다..',
		applicationSubmitedD3: '계속해서 업데이트해드리겠습니다.',
		applicationSubmitedGT: '내 캐비닛으로 이동',
		applicationSubmitedET: 'Tradeview 살펴보기',
		apEmailL: '이메일',
		apFirstNL: '이름',
		apFirstNP: '이름',
		apLastNL: '성',
		apLastNP: '성',
		apDateBL: '생년월일',
		apCountryBL: '출생국가',
		apCountryBP: '국가를 선택해주세요',
		apCountryNL: '국적',
		apCountryNP: '국적을 선택하세요',
		apMobileL: '모바일(선택사항)',
		apPhoneL: '전화번호',
		apPassL: 'ID/여권번호/SIN',
		apPassP: 'ID, 여권 또는 SIN을 입력하세요.',
		apPassT:
			'신분증 중 하나만 입력하시면 됩니다. SIN(사회보험번호)은 캐나다 사용자에게만 적용됩니다.',
		apPassDL: 'ID/여권/SIN 만료일',
		apGenderL: '성별',
		apGenderP: '선택하세요',
		apMaritalL: '결혼 여부',
		apMaritalP: '선택하세요',
		apCountryRL: '국가',
		apCountry: '국가',
		apCountryRLTooltip: `이는 귀하의 비즈니스가 주로 위치한 국가를 의미합니다. 정확한 정보는 지역 요구 사항 및 규정을 기반으로 서비스를 맞춤화하는 데 도움이 됩니다.귀하의 국가가 옵션에 포함되지 않은 경우, 해당 지역에서는 서비스를 제공할 수 없음을 알려드립니다.`,
		apCountryRLResidence: '거주 국가',
		apCountryRP: '국가를 선택해주세요',
		apProvinceRL: '주/도',
		apProvinceRP: '주/도를 선택하세요',
		apCityRL: '시',
		apCityRP: '도시를 선택하세요',
		apStreethRL: '도로명',
		apStreethRD: '도로명을 입력하세요.',
		apStreethNL: '도로명 번호 ',
		apStreethND: '도로명 번호를 입력하세요',
		apPostCL: '우편번호',
		apPostCD: '우편번호를 입력하세요',
		appAddresT:
			'귀하의 거주 국가가 옵션에 나열되지 않은 경우, 귀하의 지역에서는 서비스를 제공할 수 없음을 알려드리게 되어 유감입니다.',
		modalCompleteT: '모든 정보가',
		modalCompleteT2: '완료되었습니다!',
		modalCompleteP:
			'프로세스를 완료하는 데 필요한 모든 정보를 확보했습니다. 마지막 단계는 계좌 소유자의 서명을 추가하고 신청서를 제출하는 것입니다. 여행이 거의 완료되었습니다!',
		modalRegulationT: '회원가입을',
		modalRegulationT2: '진행할 수 없습니다.',
		modalRegulationP:
			'죄송합니다. 규제으로 인해 미국 영토에 거주하는 고객분들에게는 서비스를 제공할 수 없습니다.',
		modalRegulationP2: 'Tradeview 가입에 관심을 가져주셔서 감사합니다.',
		signatureTM2:
			'서명이 이전에 업로드한 문서의 서명과 일치하는지 확인하세요. 허용되는 파일 형식은 jpg, jpeg, png이며 최대 파일 크기는 3MB입니다.',
		submitModal:
			'양식에서 일부 오류를 발견했습니다. 검토 후 다시 시도하세요. 문제가 지속되면 지원팀에 문의하세요.',
		areaPH: '지역',
		phonePH: '휴대전화 번호를 입력하세요',
		emailPH: '이메일을 입력하세요',
		errorUpload: '올바른 형식과 크기로 파일을 업로드해 주세요.',
		apBtnContinue: '다음',
		apBtnSubmit: '제출',
		apBtnBack: '뒤로',
		apBtnRegulation: '규제 페이지 방문',
		complete: '작성완료',
		pending: '기다려주세요',
		rejected: '거부됨',
		accepted: '승인됨',
		enterFirstName: '이름을 입력하세요.',
		enterLastName: '성을 입력하세요',
		enterAnEmail: '이메일을 입력하세요',
		sendInvitation: '초대장 보내기',
		invitationSent: '초대장을 성공적으로 전송하였습니다!',
		invitationSentDesc:
			'사용자2 추가 페이지에서 신청 진행 상황을 추적하실 수 있습니다..',
		modifiedInvitation: '이용자2 정보가 성공적으로 업데이트되었습니다.',
		modifiedInvitationDesc:
			'이용자2의 이메일로 초대장이 전송되었습니다. 계좌이용자 2 추가페이지에서 진행상황을 확인하실 수 있습니다.',
		notModifiedInvitation: '이용자2 정보가 성공적으로 업데이트되었습니다.',
		notModifiedInvitationDesc:
			'사용자2 추가 페이지에서 신청 진행 상황을 추적하실 수 있습니다.',
		resend: '초대장 다시 보내기',
		saveShareholder: '주주 저장',
		shareholderToComplete: '주주에게 완료 요청',
		companyDocuments: '법인서류 인증',
		companyDocumentsDesc:
			'귀하의 계정을 인증하여 규정 준수를 보장하고 귀하의 비즈니스 요구에 맞게 서비스를 조정하십시오.',
		documentUpload: '문서 업로드',
		documentUploadTooltip1:
			'파일의 정보와 이미지가 명확하고 이해하기 쉬운지 확인하세요.',
		documentUploadTooltip2:
			'현재 가지고 있는 문서를 자유롭게 업로드하세요. 일부 문서가 누락되어도 걱정하지 마세요. 요청 시 나중에 업로드하거나 보낼 수 있습니다.',
		documentUploadDesc:
			'지금 문서를 업로드할지 아니면 나중에 저장할지 선택하세요. 업로드를 선택한 경우 파일을 끌어서 놓거나 폴더를 찾아보세요.',
		articlesIncorp: '법인정관 (Articles of incorporation)',
		certificateIncorp: '법인설립증명서 (Certificate of incorporation)',
		shareholderBreak: '주주 현황 (Shareholder breakdown)',
		corporateBank: '법인 은행 명세서 (Corporate bank statement)',
		memorandumArticles:
			'협회 각서/정관 (Memorandum of association/articles of association)',
		uploadNow: '지금 업로드하시겠습니까?',
		imageType:
			'파일 형식이 JPEG, JPG 또는 PNG이며 크기가 3MB를 초과하지 않도록 하세요.',
		sharesError:
			'주주와 계좌 보유자의 비율을 합친 비율은 100%를 초과할 수 없습니다. 다시 시도해 주세요.',
		inviteConfirmation: '모든 초대장을 보낼 준비가 되셨나요?',
		inviteConfirmationDesc:
			'모든 주주들에게 이메일 초대장을 보냅니다. 발송 후에는 주주를 추가하실 수 없습니다.',
		inviteSent: '초대장이 성공적으로 발송되었습니다!',
		inviteSentDesc:
			'계좌이용자 2 추가페이지에서 진행상황을 확인하실 수 있습니다.',
		deleteHolder: '정말로 이 주주를 삭제하시겠습니까?',
		deleteHolderDesc:
			'귀하의 법인계정에 연결된 주주 중 한명을 제거하려고 합니다. 계속하시겠습니까?',
		unableToContinue: '계속 진행할 수 없습니다',
		unableToContinueDesc:
			'제공한 이메일 주소는 이미 Tradeview 계정과 연동되어 있습니다. 계속하려면 다른 이메일을 제공해 주세요.',
		provideAnother: '다른 이메일 주소를 제공하세요',
		duplicated: '중복됨',
		duplicatedDesc:
			'입력하신 이메일 주소는 이미 Tradeview 계정에 연결되어 있습니다. 계속하려면 다른 이메일 주소를 입력해 주세요.',
	},

	//validations yup app process
	yup: {
		selectOption: '옵션을 선택해주세요',
		phone: '전화번호에는 문자나 기호가 포함될 수 없습니다.',
		phoneValid: '유효한 번호를 입력하세요',
		dateofBirth: '생년월일을 입력해주세요',
		validEmail: '유효한 이메일을 입력하세요',
		mustBeAdult:
			'유효한 생년월일을 입력하세요. 계속하려면 만 18세 이상이어야 합니다.',
		passport: '주민등록번호를 입력해주세요',
		passportValid: '유효한 번호를 입력하세요',
		passportexpirationdate: '유효한 날짜를 입력하세요.',
		passportexpirationdateValid:
			'유효한 만료일을 입력하세요. 현재 제출된 서류만 인정됩니다',
		streetname: '도로명을 입력하세요.',
		streetnumber: '도로명 번호를 입력하세요.',
		postcode: '우편번호를 입력해주세요',
		taxReference: '주민등록번호 13자리를 ' - ' 없이 입력해주세요..',
		pepstatus: '요청한 정보를 입력해주세요.',
		pepstatusValid: '최대 문자 수를 초과했습니다.',
		employer: '고용주명을 입력하세요',
		occupation: '직업을 입력하세요',
		employerAddress: '고용주 주소를 입력하세요',
		employerpostalcode: '고용주 우편번호를 선택하세요',
		businesstype: '베네피트 코퍼레이션(B Corp)',
		industry: '업종을 입력해주세요',
		business_location: '사업자 주소를 입력하세요',
		business_name: '사업자명을 입력하세요',
		business_website: '회사 홈페이지 URL을 입력하세요',
		bankruptciesdetails: '귀하의 파산 소속 정보를 적어주세요.',
		acknowledgement: '진행하려면 확인란에 체크해 주세요.',
		agree: '계속하려면 확인란을 선택하세요.',
		expirationDate: '유효하지 않은 여권 만료일',
		invalidEmail: '유효하지 않은 이메일 형식',
		EmailRequired: '이메일이 필요합니다',
		companyName: '모회사의 이름을 입력하세요.',
		email: '회사 이메일을 입력하세요',
		businessDescription: '요청한 정보를 입력해주세요.',
		required: '이 필드는 필수입니다',
		jobTitle: '직함을 입력해 주세요',
		emailAlreadyRegistered:
			'입력한 이메일이 이미 등록되었습니다. 다른 이메일을 사용해주세요.',
	},

	//helper arrays app proces
	array: {
		usd: 'USD',
		eur: 'EUR',
		gbp: 'GBP',
		female: '여성',
		male: '남성',
		noBinary: '비 바이너리',
		other: '이외',
		noAnswer: '나는 대답하지 않는 것을 선호한다',
		single: '미혼',
		married: '기혼',
		divorced: '이혼',
		windowed: '사별',
		registered: '파트너십 등록',
		yes: '예',
		no: '아니요',
		employed: '정직원',
		selfEmployed: '자영업자',
		retired: '은퇴',
		unemployed: '무직',
		aerospaceAndDefense: '항공우주 및 국방',
		agriculture: '농업',
		automotive: '자동차',
		construction: '건설',
		consulting: '컨설팅',
		eCommerce: '이커머스',
		education: '교육',
		energyAndUtilities: '에너지 및 유틸리티',
		entertainmentAndMedia: '엔터테인먼트 및 미디어',
		fashionAndApparel: '패션 및 의류',
		financeAndBanking: '금융 및 은행',
		foodAndBeverage: '요식업',
		government: '정부',
		healthAndWellness: '건강과 복지',
		hospitality: '호텔 관광업',
		itTechnology: 'IT/기술',
		legalServices: '법률 서비스',
		manufacturing: '제조업',
		marketingAndAdvertising: '마케팅 및 광고',
		nonProfitCharity: '비영리/자선',
		realEstate: '부동산',
		retail: '소매',
		benefitCorporation: '베네피트 코퍼레이션(B Corp)',
		cooperative: '협동조합',
		cooperativeCorporation: '협동조합',
		corporation: '법인',
		familyOwnedBusiness: '가족 소유 기업',
		franchise: '프렌차이즈',
		holdingCompany: '홀딩 컴퍼니',
		jointVenture: '합작 투자',
		llc: '유한 책임 회사(LLC)',
		lllp: '유한책임합자회사(LLLP)',
		llp: '유한 책임 파트너십(LLP)',
		lp: '합자회사(LP)',
		nonprofitOrganization: '비영리단체',
		partnership: '파트너쉽',
		privateEquityFirm: '사모펀드',
		professionalCorporation: '전문기업(PC)',
		publiclyTradedCompany: '상장회사',
		sCorporation: '에스코퍼레이션',
		socialEnterprise: '사회적 기업',
		soleProprietorship: '개인 사업자',
		serviceProvider: '서비스업',
		telecommunications: '통신',
		transportationAndLogistics: '운송 및 물류',
		apprenticeship: '견습',
		casual: '캐주얼',
		contractual: '계약',
		freelance: '프리랜서',
		fullTime: '풀타임',
		internship: '인턴십',
		onDemand: '주문형',
		outsourcedOrOffshore: '아웃소싱 또는 해외',
		partTime: '파트타임',
		permanent: '영구계약',
		projectBased: '프로젝트 기반',
		regular: '정기계약',
		seasonal: '시즌계약',
		temporary: '일시계약',
		volunteer: '자원 봉사자',
		benefitCorporation: '베네피트 코퍼레이션(B Corp)',
		cooperative: '협동조합',
		cooperativeCorporation: '협동조합',
		corporation: '법인',
		familyOwnedBusiness: '가족 소유 기업',
		franchise: '프렌차이즈',
		holdingCompany: '홀딩 컴퍼니',
		jointVenture: '합작 투자',
		limitedLiabilityCompany: '유한 책임 회사(LLC)',
		limitedLiabilityLimitedPartnership: '유한책임합자회사(LLLP)',
		limitedLiabilityPartnership: '유한 책임 파트너십(LLP)',
		limitedPartnership: '합자회사(LP)',
		nonprofitOrganization: '비영리단체',
		partnership: '파트너쉽',
		privateEquityFirm: '사모펀드',
		professionalCorporation: '전문기업(PC)',
		publiclyTradedCompany: '상장회사',
		sCorporation: '에스코퍼레이션',
		socialEnterprise: '사회적 기업',
		soleProprietorship: '개인 사업자',
		below25: '$25,000 USD 미만',
		between50: '$25,000 USD - $50,000 USD',
		between100: '$50,000 USD - $100,000 USD',
		over100: '$100,000 USD 이상',

		// CORPORATE
		below50mil: '$50,000 USD 미만',
		between100mil: '$50,000 USD - $100,000 USD',
		between500mil: '$100,000 USD - $500,000 USD',
		between1000mill: '$500,000 USD - $1,000,000 USD 사이',
		over1000mill: '$1,000,000 USD 초과',
		// END CORPORATE

		savingsFromSalary: '저축',
		governmentAid: '정부 지원',
		sale: '판매',
		investmentsDividends: '투자, 배당',
		incomeFromATrust: '신탁 소득',
		letting: '렛팅',
		inheritance: '상속',
		donation: '기부',
		loan: '대출',
		incomeFromSelfEmployment: '자영업 소득',
		parentsPartnerOrOther: '부모, 파트너 또는 기타',
		relativeSupport: '친가 지원',
		hedging: '헤징',
		speculation: '추측',
		longTermInvesting: '장기투자',
		proprietaryTrading: '프랍트레이딩',
		drawSignature: '서명하기',
		uploadSignature: '서명 업로드',
		neverTraded: '첫거래 입니다',
		zeroToFiveYears: '0-5년',
		sixToTenYears: '6~10년',
		overTenYears: '10년 이상',
		below50K: '$50,000 USD 미만',
		between50KTo100K: '$50,000 USD - $100,000 USD',
		between100KTo500K: '$100,000 USD - $500,000 USD',
		over500K: '$500,000 USD 이상',
		daily: '매일',
		weekly: '일주일에 한번',
		monthly: '한달에 한번',
		quarterly: '분기에 한번',
		semiAnnually: '반년에 한번',
		clientAgreement: '고객 계약',
		electronicTradingAgreement: '전자거래계약',
		riskDisclosure: '리스크 공지',
		privacyPolicy: '개인 정보 보호 약관',
		consentToDelivery: '전자 매체를 통한 진술 전달에 대한 동의',
		commissionAgreement: '커미션 계약',
		termsAndConditions: '이용약관',
		swapFreeAccount: '스왑 프리 동의',
		swapFree: '스왑 프리 계좌 신청서',
		forex: '외환',
		stocks: '주식',
		futures: '선물',
		months: {
			january: '1월',
			february: '2월',
			march: '3월',
			april: '4월',
			may: '5월',
			june: '6월',
			july: '7월',
			august: '8월',
			september: '9월',
			october: '10월',
			november: '11월',
			december: '12월',
		},
		passport: '여권',
		identityCard: '신분증 번호',
		residencePermit: '거주 허가증',
		driversLicense: '운전 면허증',
		utilityBill: '공과금 청구서',
		bankStatement: '은행 명세서',
		certificateResidency: '거주증명서',
		today: '오늘',
		lastWeek: '지난주',
		lastMonth: '지난달',
		last3Months: '지난 3개월',
		last6Months: '지난 6개월',
		costumPeriod: '기간 선택',
		lastQuarter: '지난 분기',
		lastSemester: '지난 학기',
		lastYear: '지난해',
		step: '단계',
		sell: '판매',
		buy: '구매',
		transfer: '이체',
		deposit: '입금',
		withdrawal: '출금',
		payout: '지급',
		adjustment: '조정',
		live: '실거래',
		demo: '데모',
	},
	//MFA
	mfa: {
		body: '비밀번호 외에 2차 인증 방법을 설정하여 계정을 더욱 안전하게 보호하세요.',
		text: '2단계 인증을 활성화하면 이메일 주소로 전송된 인증 코드와 함께 비밀번호를 입력해야 합니다.',
		turn: 'Turn',
		on: '~에',
		off: '끄다',
		confirm: '완료하기',
		textTwo: 'MFA를 비활성화하시겠습니까?',
		yes: '예',
		no: '아니요',
	},

	progress: {
		title: '회원가입 진행상황',
		progress1: '인적정보',
		progress2: '세금 거주',
		progress3: '플랫폼과 화폐',
		progress4: '채용내용',
		progress5: '재무정보',
		progress6: 'Experience',
		progress7: 'ID type',
		progress8: '거주지 증명서',
		progress9: '승인',
		progress10: '서명',
		progress11: '추가 리스크 공지',
		progress12: '신청서 제출',
		progress13: '두번째 계좌 이용자',
	},

	btns_: {
		back: '뒤로',
		continue: '다음',
		cancel: '취소',
		yesDelete: '예, 삭제합니다',
		noDelete: '뒤로',
		resendInvitations: '초대장 다시 보내기s',
		of: 'of',
		yesImSure: '네, 나가겠습니다.',
		submit: '제출하기',
	},
	trading_tools: {
		main_title: '당신의 거래 도구',
		main_desc:
			'우리의 강력한 거래 도구를 사용하여 더 스마트하고 데이터 기반의 결정을 내리세요. 시장에서 경쟁 우위를 점할 수 있도록 설계되었습니다.',
		calculatorSuite: '계산기 모음',
		calculatorSuiteDesc:
			'전략적 거래를 위한 필수 도구를 모두 갖추세요! 이 강력한 도구 키트는 거래 수준에 관계없이 여러분의 잠재력을 발휘하도록 설계되었습니다.',
		tradegatehub: 'TradeGATEHub',
		tradegatehubDesc:
			'트레이더 및 전문가와의 실시간 채팅, 라이브 스트리밍, 실시간 시장 뉴스를 포함한 성장 중심의 무료 리소스에 액세스하여 자신감을 가지고 시장을 탐색하세요.',
		surfsup: 'Surf’s Up!',
		surfsupDesc:
			'최신 시장 개발에 대한 최신 정보를 유지하고 새로운 전략, 통찰력 및 분석을 탐색하십시오.',
	},
	authErrors: {
		default: '예기치 않은 오류가 발생했습니다. 나중에 다시 시도해주세요.',

		register: {
			usernameExists:
				'이 이메일은 이미 등록되어 있습니다. 로그인하거나 다른 이메일을 사용해주세요.',
			invalidPassword:
				'비밀번호는 최소 8자 이상이며, 소문자, 대문자, 숫자, 특수문자를 각각 하나 이상 포함해야 합니다.',
			invalidParameter:
				'일부 정보가 잘못되었거나 누락되었습니다. 정보를 확인하고 다시 시도해주세요.',
			aliasExists:
				'이 이메일 또는 전화번호는 이미 다른 계정에 연결되어 있습니다. 로그인하거나 다른 것을 사용해주세요.',
			limitExceeded:
				'인증 코드를 너무 많이 요청하셨습니다. 잠시 후 다시 시도해주세요.',
			notAuthorized:
				'인증 문제로 인해 가입을 처리할 수 없습니다. 나중에 다시 시도해주세요.',
			codeMismatch:
				'입력한 코드가 유효하지 않습니다. 확인하고 다시 시도해주세요.',
		},

		login: {
			userNotFound:
				'입력한 이메일이 등록되어 있지 않습니다. 오타를 확인하거나 새 계정을 등록해주세요.',
			notAuthorized:
				'로그인에 실패했습니다. 자격 증명을 확인하고 다시 시도해주세요. 문제가 계속되면 문의해주세요.',
			invalidPassword:
				'입력한 자격 증명이 올바르지 않습니다. 확인하고 다시 시도해주세요.',
			codeMismatch:
				'입력한 코드가 유효하지 않습니다. 확인하고 다시 시도해주세요.',
			userNotConfirmed:
				'로그인하려면 계정을 확인해주세요. 이메일 또는 전화에서 인증 코드를 확인하세요.',
			passwordResetRequired:
				'로그인 전에 비밀번호를 재설정해주세요. 이메일로 전송된 지침을 따르세요.',
			expiredCode:
				'인증 코드가 만료되었습니다. 새 코드를 요청하고 다시 시도해주세요.',
		},

		resetPass: {
			userNotFound:
				'입력한 이메일이 등록되어 있지 않습니다. 오타를 확인하거나 새 계정을 등록해주세요.',
			invalidParameter:
				'필수 정보가 잘못되었거나 누락되었습니다. 정보를 검토하고 다시 시도해주세요.',
			notAuthorized:
				'보안 매개변수가 누락되어 인증에 실패했습니다. 다시 시도하거나 문의해주세요.',
			limitExceeded:
				'비밀번호 재설정을 너무 많이 시도했습니다. 잠시 후 다시 시도해주세요.',
			internalError: '문제가 발생했습니다. 나중에 다시 시도해주세요.',
			invalidLambda: '요청을 처리할 수 없습니다. 나중에 다시 시도해주세요.',
			invalidSmsPolicy:
				'SMS 인증을 보낼 수 없습니다. 나중에 다시 시도해주세요.',
			codeMismatch:
				'입력한 코드가 올바르지 않습니다. 확인하고 다시 시도해주세요.',
			expiredCode:
				'입력한 코드가 만료되었습니다. 새 코드를 요청하고 다시 시도해주세요.',
			invalidPassword:
				'비밀번호는 최소 8자 이상이며, 소문자, 대문자, 숫자, 특수문자를 각각 하나 이상 포함해야 합니다.',
		},
	},
}
